import {
  ACADEMIC_TITLE_DOCTOR,
  ACADEMIC_TITLE_DOCTOR_DOCTOR_MEDICINE,
  ACADEMIC_TITLE_DOCTOR_MEDICINE,
  ACADEMIC_TITLE_DOCTOR_MULTIPLEX,
  ACADEMIC_TITLE_PROFESSOR,
  ACADEMIC_TITLE_PROFESSOR_DOCTOR,
  ACADEMIC_TITLE_PROFESSOR_ORDINARIUS,
  ACCOUNT_ROLE_ADMIN,
  ACCOUNT_ROLE_ADMIN_EDIT_CAREPROVIDER,
  ACCOUNT_ROLE_ADMIN_EDIT_CARESEEKER,
  ACCOUNT_ROLE_ADMIN_EDIT_CONSULTANT,
  ACCOUNT_ROLE_ADMIN_READ_ONLY,
  ACCOUNT_ROLE_ADMIN_TRANSLATIONS,
  ACCOUNT_ROLE_CARESEEKER_CARE,
  ACCOUNT_ROLE_CARESEEKER_HOSPITALIZATION,
  ACCOUNT_ROLE_CARESEEKER_PSYCHIATRIC_CARE,
  ACCOUNT_ROLE_CARESEEKER_REHAB,
  ACCOUNT_ROLE_CARESEEKER_USER_MANAGEMENT,
  ACCOUNT_ROLE_CLINICAL_DOCUMENTATION,
  ACCOUNT_ROLE_DTA_APPROVER,
  ACCOUNT_ROLE_MEDICAL_SUPPLIES,
  ACCOUNT_ROLE_PREDICT,
  ACCOUNT_ROLE_RECEIVER_ADMISSIONS,
  ACCOUNT_ROLE_RECEIVER_ANALYTICS,
  ACCOUNT_ROLE_RECEIVER_BASE_ROLE,
  ACCOUNT_ROLE_RECEIVER_CONTACT,
  ACCOUNT_ROLE_REPORT,
  ACCOUNT_ROLE_SCRIBE,
  ACCOUNT_ROLE_SENDER_API_CREATE_PATIENT,
  ACCOUNT_ROLE_SENDER_IT,
  ACCOUNT_ROLE_TRANSPORT,
  ACCOUNT_ROLE_VOICE,
  ACCOUNT_STATUS_ACTIVE,
  ACCOUNT_STATUS_CREATED,
  ACCOUNT_STATUS_INACTIVE,
  ACCOUNT_TYPE_API,
  ACCOUNT_TYPE_CALLCENTER_DEPRECATED,
  ACCOUNT_TYPE_CAREPROVIDER_DEPRECATED,
  ACCOUNT_TYPE_CLINIC_DEPRECATED,
  ACCOUNT_TYPE_EXTERNAL,
  ACCOUNT_TYPE_PROVIDER_SEARCH,
  ACCOUNT_TYPE_STAFF,
  ACCOUNT_TYPE_TOOL,
  ADMISSIONS_FORM_SOLUTIONS,
  AUCTION_REQUEST_ACCEPTED,
  AUCTION_REQUEST_ATTRIBUTED,
  AUCTION_REQUEST_CREATED,
  AUCTION_REQUEST_DECLINED,
  AUCTION_REQUEST_ORIGIN,
  AUCTION_REQUEST_REJECTED,
  AUCTION_REQUEST_SENT,
  AUCTION_REQUEST_UNAVAILABLE,
  CANDIDATES_STATUS_FAILED,
  CANDIDATES_STATUS_NOT_STARTED,
  CANDIDATES_STATUS_PENDING,
  CANDIDATES_STATUS_SUCCESS,
  CARDIOVASCULAR_EQUIPMENT,
  CAREPROVIDER_ACTIVE,
  CAREPROVIDER_CREATED,
  CAREPROVIDER_DUPLICATE,
  CAREPROVIDER_INACTIVE,
  CAREPROVIDER_INVALID,
  CAREPROVIDER_PENDING_ACCOUNT_ACTIVATION,
  CAREPROVIDER_PROFILE_FILLED_DEPRECATED,
  CAREPROVIDER_TEST_NOT_ANSWERED_DEPRECATED,
  CAREPROVIDER_TEST_SENT_DEPRECATED,
  CAREPROVIDER_TRASH,
  CARESEEKER_STATUS_ACTIVE,
  CARESEEKER_STATUS_CREATED,
  CARESEEKER_STATUS_DUPLICATE,
  CARESEEKER_STATUS_INACTIVE,
  CARESEEKER_STATUS_ONBOARDING,
  CARESEEKER_STATUS_SALES,
  CARESEEKER_STATUS_TRASH,
  CARE_DURATION_FIVE_MONTHS,
  CARE_DURATION_FOUR_MONTHS,
  CARE_DURATION_ONE_DAY,
  CARE_DURATION_ONE_MONTH,
  CARE_DURATION_ONE_WEEK,
  CARE_DURATION_SIX_MONTHS_PLUS,
  CARE_DURATION_THREE_MONTHS,
  CARE_DURATION_THREE_WEEKS,
  CARE_DURATION_TWO_MONTHS,
  CARE_DURATION_TWO_WEEKS,
  CARE_DURATION_UNKNOWN,
  CARE_FREQUENCY,
  CARE_LEVELS,
  COMMUNICATION_BAD,
  COMMUNICATION_GOOD,
  COMMUNICATION_MODERATE,
  COMPANY_STATUSES,
  COMPANY_TYPES,
  CONSCIOUSNESS_COMATOSE,
  CONSCIOUSNESS_DROWSY,
  CONSCIOUSNESS_LUCID,
  CONSCIOUSNESS_QUALITATIVE_DISTURBANCE,
  CONSCIOUSNESS_QUANTITATIVE_REDUCTION,
  CONSCIOUSNESS_SOMNOLENT,
  CONSCIOUSNESS_SOPOROUS,
  CONSULTANT_STATUS_ACTIVE,
  CONSULTANT_STATUS_CREATED,
  CONSULTANT_STATUS_INACTIVE,
  CONTACT_BEHAVIOUR_COOPERATIVE,
  CONTACT_BEHAVIOUR_MOSTLY_COOPERATIVE,
  CONTACT_BEHAVIOUR_SEVERELY_LIMITED,
  CONTACT_BEHAVIOUR_UNSTABLE,
  COST_PAYER_TYPE_PRIVATE_HEALTH_INSURANCE,
  COST_PAYER_TYPE_PUBLIC_HEALTH_INSURANCE,
  CURRENT_CARE_BASE_TYPES,
  CURRENT_CARE_FACILITY_TYPES,
  DAILY_STRUCTURE_IRREGULAR_ATTENDANCE,
  DAILY_STRUCTURE_NO_PARTICIPATION,
  DAILY_STRUCTURE_PARTICIPATES_PREDOMINANTLY,
  DAILY_STRUCTURE_PARTICIPATES_RELIABLY,
  DEMENTIA_NO,
  DEMENTIA_UNKNOWN,
  DEMENTIA_YES,
  DIGESTIVE_ENDOSCOPY,
  ELIGIBILITY_REJECT_ANOTHER_FORM_OF_REHAB_SOUGHT,
  ELIGIBILITY_REJECT_DIFFERENT_COST_PAYER_RESPONSIBLE,
  ELIGIBILITY_REJECT_NOT_ELIGIBLE,
  ELIGIBILITY_REJECT_OTHER,
  EMPLOYMENT_STATUS_CIVIL_SERVANT,
  EMPLOYMENT_STATUS_EMPLOYEE,
  EMPLOYMENT_STATUS_MASTER_FOREMAN,
  EMPLOYMENT_STATUS_NOT_EMPLOYED,
  EMPLOYMENT_STATUS_SELF_EMPLOYED,
  EMPLOYMENT_STATUS_SEMI_SKILLED_WORKER,
  EMPLOYMENT_STATUS_SKILLED_WORKER,
  EMPLOYMENT_STATUS_TRAINEE,
  EMPLOYMENT_STATUS_UNSKILLED_EMPLOYEE,
  ENDANGERMENT_OF_OTHERS_NO,
  ENDANGERMENT_OF_OTHERS_UNKNOWN,
  ENDANGERMENT_OF_OTHERS_YES,
  FACILITY_ASSISTED_LIVING,
  FACILITY_COMPANIONSHIP,
  FACILITY_DAILY_LIVING_SUPPORT_SERVICES,
  FACILITY_DAY_CARE,
  FACILITY_DAY_HOSPITALIZATION,
  FACILITY_FULLTIME_COMPANIONSHIP,
  FACILITY_FULLTIME_MOBILE_CARE,
  FACILITY_FULL_HOSPITALIZATION,
  FACILITY_HOME_CARE,
  FACILITY_HOSPICE_ASSOCIATION,
  FACILITY_HOSPICE_MOBILE,
  FACILITY_HOSPICE_PARTIALLY_MOBILE,
  FACILITY_HOSPICE_STATIC,
  FACILITY_MEDICAL_SUPPLIES,
  FACILITY_MOBILE_CARE,
  FACILITY_NIGHT_CARE_MOBILE,
  FACILITY_NIGHT_CARE_STATIC,
  FACILITY_PURE_INTENSIVE_CARE,
  FACILITY_REHAB_DAY_HOSPITALIZATION,
  FACILITY_REHAB_FULL_HOSPITALIZATION,
  FACILITY_REHAB_MOBILE,
  FACILITY_SHARED_FLAT,
  FACILITY_SHORT_TERM_CARE,
  FACILITY_STATIC_CARE,
  FILE_CATEGORY_AD,
  FILE_CATEGORY_AND,
  FILE_CATEGORY_APF,
  FILE_CATEGORY_BIX,
  FILE_CATEGORY_BTR,
  FILE_CATEGORY_CC,
  FILE_CATEGORY_CTB,
  FILE_CATEGORY_ECG,
  FILE_CATEGORY_ERR,
  FILE_CATEGORY_FSO,
  FILE_CATEGORY_GI,
  FILE_CATEGORY_IMG,
  FILE_CATEGORY_ISO,
  FILE_CATEGORY_MDL,
  FILE_CATEGORY_MP,
  FILE_CATEGORY_MR,
  FILE_CATEGORY_MSR,
  FILE_CATEGORY_PCR,
  FILE_CATEGORY_PR,
  FILE_CATEGORY_PRE,
  FILE_CATEGORY_RBA,
  FILE_CATEGORY_RER,
  FILE_CATEGORY_SN,
  FILE_CATEGORY_TRC,
  FILE_CATEGORY_WP,
  FILE_ERROR_FILE_SIZE,
  FILE_ERROR_FILE_TYPE,
  FILE_SHARE_MODE_ALL,
  FILE_SHARE_MODE_NONE,
  FILE_SHARE_MODE_SELECTED,
  FILTER_AGE,
  FILTER_BLACKLISTED_INSURANCE,
  FILTER_CAPACITY_BACKOFF,
  FILTER_CAPACITY_START_DATE,
  FILTER_CONTACTED,
  FILTER_DISTANCE,
  FILTER_NO_BED_AVAILABLE,
  FILTER_PREREQUISITE,
  FILTER_RECEIVER_BLACKLISTED,
  FILTER_REMOVED_SOLUTION,
  FILTER_SENDER_BLACKLISTED,
  FILTER_SERVICE,
  FILTER_SOLUTION,
  FILTER_SPECIALIZATION,
  FILTER_STATUS,
  FILTER_THROTTLE,
  FILTER_ZIPCODES,
  FORM_YES_NO_NEGATIVE,
  FORM_YES_NO_POSITIVE,
  GENDER,
  GRANTS_COMBINATION_OF_BOTH,
  GRANTS_MONEY_FROM_INSURANCE,
  GRANTS_MONEY_FROM_STATE,
  GRANT_STATUS_APPLIED_FOR,
  GRANT_STATUS_EXISTS,
  GRANT_STATUS_NOT_APPLIED,
  GUARDIAN,
  HOME_CARE_SPECIALIZATION_COMPRESSION_THERAPY,
  HOME_CARE_SPECIALIZATION_DECUBITUS_PROPHYLAXIS,
  HOME_CARE_SPECIALIZATION_DRAINAGE,
  HOME_CARE_SPECIALIZATION_ENTERAL_NUTRITION,
  HOME_CARE_SPECIALIZATION_INCONTINENCE,
  HOME_CARE_SPECIALIZATION_INCONTINENCE_DISCHARGING,
  HOME_CARE_SPECIALIZATION_INFUSION_THERAPY,
  HOME_CARE_SPECIALIZATION_MEDICATION,
  HOME_CARE_SPECIALIZATION_MONITORING,
  HOME_CARE_SPECIALIZATION_OXYGEN,
  HOME_CARE_SPECIALIZATION_PAIN_THERAPY,
  HOME_CARE_SPECIALIZATION_PARENTERAL_NUTRITION,
  HOME_CARE_SPECIALIZATION_RESPIRATORY_THERAPY,
  HOME_CARE_SPECIALIZATION_STOMA,
  HOME_CARE_SPECIALIZATION_TRACHEOSTOMY_THERAPY,
  HOME_CARE_SPECIALIZATION_VENTILATION,
  HOME_CARE_SPECIALIZATION_WOUND_CARE,
  IDENTITY_PROVIDER_TYPE,
  INFECTION_AND_GERMS_REQUIRES_CLOSTRIDIEN,
  INFECTION_AND_GERMS_REQUIRES_FOUR_MRGN,
  INFECTION_AND_GERMS_REQUIRES_ISOLATION,
  INFECTION_AND_GERMS_REQUIRES_MRSA,
  INFECTION_AND_GERMS_REQUIRES_THREE_MRGN,
  INFECTION_AND_GERMS_REQUIRES_VRE,
  INF_SYS_CONNEXT_VIVENDI,
  INF_SYS_CURASOFT,
  INF_SYS_DAN_PRODUKTE,
  INF_SYS_GODO_SYSTEMS,
  INF_SYS_MEDIFOX,
  INF_SYS_MYNEVA,
  INF_SYS_NOVENTI_CARE,
  INF_SYS_OTHER,
  INF_SYS_SENSO,
  INF_SYS_SINFONIE,
  INF_SYS_SNAP,
  LANGUAGE_AFGHAN,
  LANGUAGE_ALBANIAN,
  LANGUAGE_AMHARIC,
  LANGUAGE_ARABIC,
  LANGUAGE_AZERBAIJANI,
  LANGUAGE_BENGAL,
  LANGUAGE_BOSNIAN,
  LANGUAGE_BULGARIAN,
  LANGUAGE_CANTONESE,
  LANGUAGE_CROATIAN,
  LANGUAGE_CZECH,
  LANGUAGE_DANISH,
  LANGUAGE_DUTCH,
  LANGUAGE_ENGLISH,
  LANGUAGE_FINNISH,
  LANGUAGE_FRENCH,
  LANGUAGE_GEORGIAN,
  LANGUAGE_GERMAN,
  LANGUAGE_GREEK,
  LANGUAGE_HEBREW,
  LANGUAGE_HINDI,
  LANGUAGE_HUNGARIAN,
  LANGUAGE_INDONESIAN,
  LANGUAGE_ITALIAN,
  LANGUAGE_JAPANESE,
  LANGUAGE_KOREAN,
  LANGUAGE_KURDISH,
  LANGUAGE_LITHUNIAN,
  LANGUAGE_MANDARIN,
  LANGUAGE_NORWEGIAN,
  LANGUAGE_PERSIAN,
  LANGUAGE_POLISH,
  LANGUAGE_PORTUGUESE,
  LANGUAGE_ROMANIAN,
  LANGUAGE_RUSSIAN,
  LANGUAGE_SERBIAN,
  LANGUAGE_SIGN,
  LANGUAGE_SPANISH,
  LANGUAGE_SWAHILI,
  LANGUAGE_SWEDISH,
  LANGUAGE_THAI,
  LANGUAGE_TIGRINYA,
  LANGUAGE_TURKISH,
  LANGUAGE_URDU,
  LANGUAGE_URKRAINIAN,
  LANGUAGE_VIETNAMESE,
  LIVING_SITUATION_ALONE,
  LIVING_SITUATION_CAREHOME,
  LIVING_SITUATION_IN_ELDERLY_HOME,
  LIVING_SITUATION_NO_RESIDENCE,
  LIVING_SITUATION_OTHER,
  LIVING_SITUATION_SHARED_FLAT,
  LIVING_SITUATION_WITH_FAMILY,
  MAIL_TYPES,
  MARITAL_STATUS,
  MENTAL_ABILITY,
  MOBILITY,
  MOBILITY_CRUTCH,
  MOBILITY_MEDICALISED_BED,
  MOBILITY_ROLLATOR,
  MOBILITY_WALKING_FRAME,
  MOBILITY_WALKING_STICK,
  MOBILITY_WALK_WITHOUT_HELP,
  MOBILITY_WALK_WITH_HELP,
  MOBILITY_WHEELCHAIR,
  MOTIVATION_BAD,
  MOTIVATION_GOOD,
  MOTIVATION_MODERATE,
  MOTIVATION_PATIENT_LOW,
  MOTIVATION_PATIENT_MOTIVATED,
  MOTIVATION_PATIENT_NO_MOTIVATION,
  MOTIVATION_PATIENT_SUFFICIENT,
  ONBOARDING_ADMINISTRATION_PHASE,
  ONBOARDING_CHAIN,
  ONBOARDING_COMPLICATED_DEPRECATED,
  ONBOARDING_CONSIDERATION_PHASE,
  ONBOARDING_INFO_PHASE,
  ONBOARDING_IT_ISSUES_DEPRECATED,
  ONBOARDING_LATE_DEPRECATED,
  ONBOARDING_MANUALLY_ADDED_BY_SENDER,
  ONBOARDING_MISSING_INFORMATION,
  ONBOARDING_NOT_REACHED_CALLCENTER_DEPRECATED,
  ONBOARDING_NOT_REACHED_DEPRECATED,
  ONBOARDING_NO_ACTION_FROM_CALLCENTER_DEPRECATED,
  ONBOARDING_NO_COMMENT_DEPRECATED,
  ONBOARDING_NO_INTEREST_DEPRECATED,
  ONBOARDING_OTHER_DEPRECATED,
  ONBOARDING_PREONBOARDING,
  ONBOARDING_PROFILE_FILLED_DEPRECATED,
  ONBOARDING_RESEND_ONBOARDING_EMAIL_DEPRECATED,
  ONBOARDING_SELF_ONBOARDING,
  ONBOARDING_TO_CALL,
  ONBOARDING_TO_CALL_BACK_DEPRECATED,
  ORIENTATION_DISORIENTED,
  ORIENTATION_LIMITED,
  ORIENTATION_ORIENTATED,
  OTHER_EQUIPMENT,
  PAGINATION_COUNT_10,
  PAGINATION_COUNT_20,
  PAGINATION_COUNT_30,
  PRIOR_EMPLOYMENT_STATUS,
  PRODUCT_FEATURES,
  PROVIDER_SEARCH_BAVARIA,
  RECEIVER_INACTIVE_REASONS,
  REFERRAL_SOURCE,
  REHABILITATION_POTENTIAL_EVALUATION_EXTREMELY_NEGATIVE,
  REHABILITATION_POTENTIAL_EVALUATION_EXTREMELY_POSITIVE,
  REHABILITATION_POTENTIAL_EVALUATION_MODERATE,
  REHABILITATION_POTENTIAL_EVALUATION_NEGATIVE,
  REHABILITATION_POTENTIAL_EVALUATION_POSITIVE,
  RELATIONSHIP_TO_PATIENT,
  RELIEF_SERVICES_PARAGRAPH_A,
  RELIEF_SERVICES_PARAGRAPH_B,
  REQUEST_CHIP_STATUS_FAX_SENT,
  REQUEST_CHIP_STATUS_NEW_FILE,
  REQUEST_CHIP_STATUS_NEW_MESSAGE,
  REQUEST_CHIP_STATUS_ONGOING_CHAT,
  REQUEST_CHIP_STATUS_PROVIDER_INACTIVE,
  REQUEST_CHIP_STATUS_REQUEST_NOT_SEEN,
  REQUEST_CHIP_STATUS_REQUEST_SEEN,
  REQUEST_CHIP_STATUS_SENT_MESSAGE_NOT_SEEN,
  REQUEST_CHIP_STATUS_SENT_MESSAGE_SEEN,
  REQUIRED_CARE_BASIC_TYPES,
  REQUIRED_CARE_TYPES,
  ROOM_TYPES,
  SEARCH_REASON,
  SEARCH_TABLE_ROW_COUNT_10,
  SEARCH_TABLE_ROW_COUNT_30,
  SEARCH_TABLE_ROW_COUNT_50,
  SEARCH_TABLE_SORTING_DEFAULT,
  SEARCH_TABLE_SORTING_DISTANCE,
  SEARCH_TABLE_SORTING_NAME,
  SEARCH_TYPE_CARE,
  SEARCH_TYPE_HOME_CARE,
  SEARCH_TYPE_HOSPITAL,
  SEARCH_TYPE_MEDICAL_SUPPLIES,
  SEARCH_TYPE_PSYCHIATRIC_CARE,
  SEARCH_TYPE_REHABILITATION,
  SELF_ENDANGERMENT_NO,
  SELF_ENDANGERMENT_UNKNOWN,
  SELF_ENDANGERMENT_YES,
  SERVICE_BASIC_CARE,
  SERVICE_BASIC_MEDICAL_CARE,
  SERVICE_CARE_FOR_CHILDREN_AND_TEENAGERS,
  SERVICE_CARE_FOR_YOUTH,
  SERVICE_CARE_PROTECTED_AREA,
  SERVICE_CLOSED_AREA,
  SERVICE_COMPANIONSHIP,
  SERVICE_DEMENTIA,
  SERVICE_DIALYSIS,
  SERVICE_ENTERALNUTRITION,
  SERVICE_GENERAL_MOBILE_PALLIATIVE_CARE,
  SERVICE_HEARING_IMPAIRED,
  SERVICE_HELPWITHEATING,
  SERVICE_INTEGRATION_ASSISTANCE,
  SERVICE_INVASIVEVENTILATION,
  SERVICE_MONITORINGBREATHING,
  SERVICE_MONITORINGCIRCULATION,
  SERVICE_MONITORINGMETABOLISM,
  SERVICE_NIGHT_MOBILE_CARE,
  SERVICE_NONINVASIVEVENTILATION,
  SERVICE_OXYGENTHERAPY,
  SERVICE_PALLIATIVE_CARE,
  SERVICE_PALLIATIVE_CERTIFICATE,
  SERVICE_PARENTERAL_NUTRITRION,
  SERVICE_PEOPLEWHOAREDANGEROUS,
  SERVICE_PEOPLEWITHADDICTIONS,
  SERVICE_PEOPLEWITHORIENTATIONDISORDER,
  SERVICE_PROTECTEDAREA,
  SERVICE_PSYCHIATRIC_CARE,
  SERVICE_SPECIALISED_INTENSIVE_NURSE,
  SERVICE_STATIC_CARE_DISABLED_PATIENTS,
  SERVICE_TAKINGOVERBODYCARE,
  SERVICE_TRACHEOSTOMY,
  SERVICE_VISUALLY_IMPAIRED,
  SHORT_TERM_CARE_GRANT_39,
  SHORT_TERM_CARE_GRANT_42,
  SHORT_TERM_CARE_GRANT_COMBINATION,
  SOLUTION_AMBULATORY_ASSISTED_COMMUNITY,
  SOLUTION_AMBULATORY_ASSISTED_LIVING,
  SOLUTION_AMBULATORY_PSYCHIATRIC_CARE,
  SOLUTION_AMBULATORY_PSYCHIATRIC_REHAB,
  SOLUTION_ASSISTED_LIVING,
  SOLUTION_DAILY_LIVING_SUPPORT_SERVICES,
  SOLUTION_DAY_CARE,
  SOLUTION_DAY_CARE_CENTRE,
  SOLUTION_DAY_HOSPITALIZATION,
  SOLUTION_FULL_HOSPITALIZATION,
  SOLUTION_FULL_TIME_MOBILE_CARE,
  SOLUTION_GERONTOPSYCHIATRIC_DAY_CLINIC,
  SOLUTION_HELP_AT_HOME,
  SOLUTION_HOME_CARE,
  SOLUTION_HOSPICE_ASSOCIATION,
  SOLUTION_HOSPICE_MOBILE,
  SOLUTION_HOSPICE_PARTIALLY_MOBILE,
  SOLUTION_HOSPICE_STATIC,
  SOLUTION_INTENSIVE_PSYCHIATRIC_CARE_HOME,
  SOLUTION_LONGTERM_PSYCHIATRIC_CARE,
  SOLUTION_MEDICAL_OCCUPATIONAL_REHAB,
  SOLUTION_MEDICAL_SUPPLIES,
  SOLUTION_MOBILE_CARE,
  SOLUTION_NIGHT_CARE_MOBILE,
  SOLUTION_NIGHT_CARE_STATIC,
  SOLUTION_PSYCHIATRIC_DAY_CLINIC,
  SOLUTION_REHAB_DAY_HOSPITALIZATION,
  SOLUTION_REHAB_DAY_HOSPITALIZATION_WITH_TRANSPORT_DEPRECATED,
  SOLUTION_REHAB_FULL_HOSPITALIZATION,
  SOLUTION_REHAB_MOBILE,
  SOLUTION_SHARED_FLAT,
  SOLUTION_SHORT_TERM_CARE_PSYCHIATRIC,
  SOLUTION_SHORT_TERM_STATIC_CARE,
  SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_ADDICTIONS,
  SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_INTELLECTUAL,
  SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_PSYCHIATRIC,
  SOLUTION_STATIC_CARE,
  SOLUTION_STATIONARY_PSYCHIATRIC_REHAB,
  SOLUTION_WFBM,
  SPECIALIZATION_ACUTE_GERIATRICS,
  SPECIALIZATION_ADDICTION,
  SPECIALIZATION_ADDICTOLOGY,
  SPECIALIZATION_ALLERGOLOGY,
  SPECIALIZATION_ANESTHESIOLOGY,
  SPECIALIZATION_ANGIOLOGY,
  SPECIALIZATION_CARDIOLOGICAL_EARLY_REHA,
  SPECIALIZATION_CARDIOLOGY,
  SPECIALIZATION_COGNITIVE_BEHAVIORAL_UNIT,
  SPECIALIZATION_DERMATOLOGY,
  SPECIALIZATION_DIABETIC_FOOT,
  SPECIALIZATION_DIABETOLOGY,
  SPECIALIZATION_DIGESTIVE_SURGERY,
  SPECIALIZATION_ENDOCRINOLOGY,
  SPECIALIZATION_ENT,
  SPECIALIZATION_GASTROENTEROLOGY,
  SPECIALIZATION_GENERAL_SURGERY,
  SPECIALIZATION_GERIATRICS,
  SPECIALIZATION_GYNAECOLOGY,
  SPECIALIZATION_HAEMATOLOGY,
  SPECIALIZATION_HEPATOLOGY,
  SPECIALIZATION_ICU_CARDIOLOGY,
  SPECIALIZATION_ICU_ECMO_CORONA,
  SPECIALIZATION_ICU_GASTROLOGY,
  SPECIALIZATION_ICU_HIGH_CORONA,
  SPECIALIZATION_ICU_LOW_CORONA,
  SPECIALIZATION_ICU_NEUROVASCULAR,
  SPECIALIZATION_INFECTIOUS_DISEASE,
  SPECIALIZATION_INTERNAL_MEDICAL_EARLY_REHA,
  SPECIALIZATION_INTERNAL_MEDICINE,
  SPECIALIZATION_MAXILLOFACIAL_SURGERY,
  SPECIALIZATION_MEDICAL_REANIMATION,
  SPECIALIZATION_NEPHROLOGY,
  SPECIALIZATION_NEUROLOGY,
  SPECIALIZATION_NEUROPEDIATRIY,
  SPECIALIZATION_NEUROSURGERY,
  SPECIALIZATION_NORMAL_STATION,
  SPECIALIZATION_OBESITY,
  SPECIALIZATION_ONCOLOGY,
  SPECIALIZATION_ONCOLOGY_BREAST_GLANDS,
  SPECIALIZATION_ONCOLOGY_CENTRAL_NERVOUS_SYSTEM,
  SPECIALIZATION_ONCOLOGY_DIGESTIVE_ORGANS,
  SPECIALIZATION_ONCOLOGY_FEMALE_GENITAL,
  SPECIALIZATION_ONCOLOGY_KIDNEY_URINARY_MALE_GENITAL,
  SPECIALIZATION_ONCOLOGY_LOCOMOTOR_ORGANS,
  SPECIALIZATION_ONCOLOGY_MALIGNANT_SYSTEMIC_DISEASES,
  SPECIALIZATION_ONCOLOGY_PHARYNX_LARYNX,
  SPECIALIZATION_ONCOLOGY_RESPIRATORY_ORGANS,
  SPECIALIZATION_ONCOLOGY_SKIN,
  SPECIALIZATION_ONCOLOGY_THYROID,
  SPECIALIZATION_OPHTHALMOLOGY,
  SPECIALIZATION_ORTHOGERIATRICS,
  SPECIALIZATION_ORTHOPEDICS,
  SPECIALIZATION_ORTHOPEDICS_LOWER_LIMBS,
  SPECIALIZATION_ORTHOPEDICS_SOS_MAINS,
  SPECIALIZATION_ORTHOPEDICS_SPINE,
  SPECIALIZATION_ORTHOPEDICS_UPPER_LIMBS,
  SPECIALIZATION_PALLIATIVE_CARE,
  SPECIALIZATION_PARENTS_AND_CHILD_REHAB,
  SPECIALIZATION_PEDIATRICS,
  SPECIALIZATION_PHASEB,
  SPECIALIZATION_PHASEC,
  SPECIALIZATION_PHASECPLUS,
  SPECIALIZATION_PHASED,
  SPECIALIZATION_PHYSICAL_MEDICINE,
  SPECIALIZATION_PLASTIC_SURGERY,
  SPECIALIZATION_PNEUMOLOGICAL_EARLY_REHA,
  SPECIALIZATION_PNEUMOLOGY,
  SPECIALIZATION_PSYCHIATRY,
  SPECIALIZATION_PSYCHOSOMATIC,
  SPECIALIZATION_RADIOLOGY,
  SPECIALIZATION_RHEUMATISM,
  SPECIALIZATION_SURGICAL_RESUSCITATION,
  SPECIALIZATION_THORACIC_SURGERY,
  SPECIALIZATION_TRAUMA_SURGERY,
  SPECIALIZATION_UROLOGY,
  SPECIALIZATION_VASCULAR_SURGERY,
  SPECIALIZATION_WEANING,
  SPECIAL_CARE_NEEDS,
  SUBSTANCE_USE_NO,
  SUBSTANCE_USE_UNKNOWN,
  SUBSTANCE_USE_YES,
  TECHNICAL_EQUIPMENT_CARDIAC_MRI,
  TECHNICAL_EQUIPMENT_COLONOSCOPY,
  TECHNICAL_EQUIPMENT_CORONAROGRAPHY,
  TECHNICAL_EQUIPMENT_CORONARY_SCANNER,
  TECHNICAL_EQUIPMENT_CTSCAN,
  TECHNICAL_EQUIPMENT_DIALYSIS,
  TECHNICAL_EQUIPMENT_DOPPLERS,
  TECHNICAL_EQUIPMENT_ENDOSCOPIC_ULTRASOUND,
  TECHNICAL_EQUIPMENT_ERCP,
  TECHNICAL_EQUIPMENT_EXERCISE_TEST,
  TECHNICAL_EQUIPMENT_GASTROSCOPY,
  TECHNICAL_EQUIPMENT_HOLTER_ECG,
  TECHNICAL_EQUIPMENT_INTERVENTION_RADIOLOGY,
  TECHNICAL_EQUIPMENT_MONITORING_BREATHING,
  TECHNICAL_EQUIPMENT_MONITORING_CIRCULATION,
  TECHNICAL_EQUIPMENT_MONITORING_METABOLISM,
  TECHNICAL_EQUIPMENT_MRI,
  TECHNICAL_EQUIPMENT_RYTHMOLOGY,
  TECHNICAL_EQUIPMENT_TOE,
  TECHNICAL_EQUIPMENT_TTE,
  TECHNICAL_EQUIPMENT_ULTRASOUND,
  TECHNICAL_EQUIPMENT_XRAY,
  TRANSPORT_TYPE_AMBULANCE_LYING_DOWN,
  TRANSPORT_TYPE_AMBULANCE_SITTING,
  TRANSPORT_TYPE_EMERGENCY_VEHICLE,
  TRANSPORT_TYPE_HELICOPTER,
  TRANSPORT_TYPE_PERSONAL_CAR,
  TRANSPORT_TYPE_PUBLIC_TRANSPORT,
  TRANSPORT_TYPE_TAXI,
  UNIVERSAL_SEARCH_RESOURCES,
  VIGILANCE_AGITATED,
  VIGILANCE_AWAKE,
  VIGILANCE_CALM,
  VIGILANCE_COMATOSE,
  VIGILANCE_RESPONSIVE,
  VIGILANCE_SOMNOLENT,
  VIGILANCE_SOPORIFIC,
  VISIT_TIME,
} from "core/consts";
import { InnerValues } from "core/types";
import Translations from "translations/types";

export type OntologyType = keyof typeof ontologies;
export type OntologyStructValue = InnerValues<
  typeof ontologies,
  keyof typeof ontologies
>;

export const ONTOLOGIES = {
  ACADEMIC_TITLE: "academicTitle",
  ACCOUNT_ROLE: "accountRole",
  ACCOUNT_ROLE_SHORT: "accountRoleShort",
  ACCOUNT_STATUS: "accountStatus",
  ACCOUNT_TYPE: "accountType",
  ADMISSIONS_FORM_SOLUTIONS: "admissionFormSolutions",
  ADMISSIONS_MENTAL_ABILITY: "admissionsMentalAbility",
  ADMISSIONS_MOBILITY: "admissionsMobility",
  AGE_OF_PATIENT: "ageOfPatient",
  BLACKLIST_RECEIVER_RULES: "blacklistReceiverRules",
  CANDIDATES_STATUS: "candidatesProgress",
  CARDIOVASCULAR_EQUIPMENT: "cardiovascularExploration",
  CARE_DURATIONS: "careDurations",
  CARE_FREQUENCY: "careFrequency",
  CARE_LEVEL: "carelevel",
  CAREPROVIDER_STATUS: "careproviderStatus",
  CARESEEKER_MODULE_STATUS: "careseekerModuleStatus",
  CARESEEKER_PRIORITY: "careseekerPriority",
  CARESEEKER_STATUS: "careseekerStatus",
  COMMUNICATION: "communication",
  COMPANY_STATUS: "companyStatus",
  COMPANY_TYPE: "companyType",
  COMPRESSION_TYPE: "compressionType",
  CONFESSION: "confession",
  CONSCIOUSNESS: "consciousness",
  CONSULTANT_STATUS: "consultantStatus",
  CONTACT_BEHAVIOUR: "contactBehaviour",
  CURRENT_CARE: "currentCare",
  CURRENT_CARE_FACILITY_TYPES: "currentCareFacilityTypes",
  DAILY_STRUCTURE: "dailyStructure",
  DECLINED_REASON: "declinedReason",
  DEMENTIA: "dementia",
  DEPENDENCY_LEVEL: "dependencyLevel",
  DIGESTIVE_ENDOSCOPY: "digestiveEndoscopy",
  DIRECT_REQUEST_TYPES: "directRequestTypes",
  ELIGIBILITY_REJECT_REASON: "eligibilityRejectReason",
  EMAIL_TYPE: "emailType",
  EMPLOYMENT_STATUS: "employmentStatus",
  ENDANGERMENT_OF_OTHERS: "endangermentOfOthers",
  FACILITY: "facility",
  FILE_CATEGORY: "fileCategory",
  FILE_ERROR: "fileError",
  FILE_SHARE_MODE: "fileShareMode",
  FOOD_HELP: "foodHelp",
  FORM_YES_NO: "formYesNo",
  GENDER: "gender",
  GENDER_EXTENDED: "genderExtended",
  GENDER_LETTER: "genderLetter",
  GRANT_STATUS: "grantStatus",
  GRANTS_TYPE: "grantsType",
  GUARDIAN_TYPE: "guardianType",
  IDENTITY_PROVIDER_TYPE: "identityProviderType",
  IMAGERY: "imagery",
  INCONTINENCE_HELP_TYPE: "incontinenceHelpType",
  INFECTION_AND_GERMS: "infectionAndGerms",
  INFORMATION_SYSTEM: "informationSystems",
  INJECTION_TYPE: "injectionType",
  INSURANCE_TYPE: "healthInsuranceType",
  INVOICE_STATUS: "invoiceStatus",
  INVOICE_TYPE: "invoiceType",
  LANGUAGE: "language",
  LIVING_SITUATION: "livingSituation",
  MARITAL_STATUS: "maritalStatus",
  MEALS: "meals",
  MENTAL_HEALTH_COMMUNICATION: "mentalHealthCommunication",
  MOBILITY: "mobility",
  MOTIVATION: "motivation",
  MOTIVATION_PATIENT: "motivationPatient",
  ONBOARDING_STATUS: "onboardingStatus",
  ORIENTATION: "orientation",
  OTHER_TECHNICAL_EQUIPMENT: "otherTechnicalEquipment",
  PAGINATION_RESULT_COUNT: "paginationResultCount",
  PATIENT_TYPE: "patientType",
  POSITION: "position",
  PRIOR_EMPLOYMENT_STATUS: "priorEmploymentStatus",
  PRODUCT_FEATURE: "productFeature",
  PROVIDER_SEARCH_NAV_TITLE: "providerSearchNavTitle",
  PROVIDER_SEARCH_REQUEST_STATUS: "providerSearchRequestStatus",
  RECEIVER_INACTIVE_REASON: "receiverInactiveReason",
  RECEIVER_TYPE_PLURAL: "receiverTypePlural",
  RECEIVER_TYPE_PLURAL_PREFERRED: "receiverTypePluralPreferred",
  RECEIVER_TYPE_SINGULAR: "receiverTypeSingular",
  RECEIVER_TYPE_SINGULAR_PREFERRED: "receiverTypeSingularPreferred",
  REFERRAL_SOURCE_MOBILE: "referralSourcesMobile",
  REFERRAL_SOURCE_STATIC: "referralSources",
  REHABILITATION_POTENTIAL: "rehabilitationPotential",
  RELATIONSHIP_TO_PATIENT: "relationship",
  RELIEF_SERVICES: "reliefServices",
  REQUIRED_CARE_BASIC_TYPES: "admissionsServicesBaseCare",
  REQUIRED_CARE_TYPES: "admissionsServices",
  ROOM_TYPE: "roomType",
  ROWS_PER_PAGE: "rowsPerPage",
  SALUTATION: "salutation",
  SEARCH_PAGE_TABLE_TITLE: "searchPageTableTitle",
  SEARCH_REASON: "searchReason",
  SEARCH_TABLE_STATUS_CHIPS: "searchTableStatusChips",
  SELF_ENDANGERMENT: "selfEndangerment",
  SERVICE: "service",
  SERVICE_EXPLANATIONS: "serviceExplanations",
  SHARE_MODES: "shareModes",
  SHORT_TERM_GRANT: "shortTermGrant",
  SOLUTION: "solution",
  SOLUTION_B_TO_C: "solutionBToC",
  SPECIAL_CARE_NEEDS: "specialCareNeeds",
  SPECIALIZATIONS: "specializations",
  SUBSTANCE_USE: "substanceUse",
  TABLE_SORTING: "tableSorting",
  TECHNICAL_EQUIPMENT: "technicalEquipment",
  TRAFFIC_LIGHT: "trafficLight",
  TRANSITIONAL_CARE_REQUEST_STATUS: "transitionalCareRequestStatus",
  TRANSPORT_TYPE: "transportType",
  UNIVERSAL_SEARCH_RESOURCE: "universalSearch",
  VIGILANCE: "vigilance",
  VISIT_TIME: "visitTime",
} as const;

export const deprecatedOntologies: {
  [index in OntologyType]?: Record<number, string>;
} = {
  [ONTOLOGIES.ACCOUNT_ROLE]: {
    [ACCOUNT_ROLE_TRANSPORT]: "transport",
  },
  [ONTOLOGIES.ACCOUNT_ROLE_SHORT]: {
    [ACCOUNT_ROLE_TRANSPORT]: "transport",
  },
  [ONTOLOGIES.ACCOUNT_TYPE]: {
    [ACCOUNT_TYPE_CALLCENTER_DEPRECATED]: "callcenter",
    [ACCOUNT_TYPE_CAREPROVIDER_DEPRECATED]: "careprovider",
    [ACCOUNT_TYPE_CLINIC_DEPRECATED]: "clinic",
  },
  [ONTOLOGIES.CAREPROVIDER_STATUS]: {
    [CAREPROVIDER_PROFILE_FILLED_DEPRECATED]: "filledProfile",
    [CAREPROVIDER_TEST_NOT_ANSWERED_DEPRECATED]: "notAnswered",
    [CAREPROVIDER_TEST_SENT_DEPRECATED]: "test",
  },
  [ONTOLOGIES.FILE_CATEGORY]: {
    [FILE_CATEGORY_BTR]: "btr",
    [FILE_CATEGORY_ECG]: "ecg",
    [FILE_CATEGORY_ERR]: "err",
    [FILE_CATEGORY_IMG]: "img",
    [FILE_CATEGORY_PCR]: "pcr",
    [FILE_CATEGORY_SN]: "sn",
  },
  [ONTOLOGIES.LIVING_SITUATION]: {
    [LIVING_SITUATION_IN_ELDERLY_HOME]: "livingSituationInElderlyHome",
  },
  [ONTOLOGIES.ONBOARDING_STATUS]: {
    [ONBOARDING_COMPLICATED_DEPRECATED]: "complicated",
    [ONBOARDING_IT_ISSUES_DEPRECATED]: "technicalIssues",
    [ONBOARDING_LATE_DEPRECATED]: "later",
    [ONBOARDING_NO_ACTION_FROM_CALLCENTER_DEPRECATED]: "noActionFromCallcenter",
    [ONBOARDING_NO_COMMENT_DEPRECATED]: "noComment",
    [ONBOARDING_NO_INTEREST_DEPRECATED]: "noInterest",
    [ONBOARDING_NOT_REACHED_CALLCENTER_DEPRECATED]: "notReached",
    [ONBOARDING_NOT_REACHED_DEPRECATED]: "notReached",
    [ONBOARDING_OTHER_DEPRECATED]: "other",
    [ONBOARDING_PROFILE_FILLED_DEPRECATED]: "profileFilled",
    [ONBOARDING_RESEND_ONBOARDING_EMAIL_DEPRECATED]: "resendOnboardingEmail",
    [ONBOARDING_TO_CALL_BACK_DEPRECATED]: "callBackLater",
  },
  [ONTOLOGIES.SOLUTION]: {
    [SOLUTION_REHAB_DAY_HOSPITALIZATION_WITH_TRANSPORT_DEPRECATED]:
      "rehabDayHospitalizationWithTransport",
  },
};

export const ontologies = {
  [CARDIOVASCULAR_EQUIPMENT]: {
    [TECHNICAL_EQUIPMENT_CARDIAC_MRI]: "cardiacMri",
    [TECHNICAL_EQUIPMENT_CORONAROGRAPHY]: "coronarography",
    [TECHNICAL_EQUIPMENT_CORONARY_SCANNER]: "coronaryScanner",
    [TECHNICAL_EQUIPMENT_EXERCISE_TEST]: "exerciseTest",
    [TECHNICAL_EQUIPMENT_HOLTER_ECG]: "holterEcg",
    [TECHNICAL_EQUIPMENT_RYTHMOLOGY]: "rhythmology",
    [TECHNICAL_EQUIPMENT_TOE]: "toe",
    [TECHNICAL_EQUIPMENT_TTE]: "tte",
  },
  [DIGESTIVE_ENDOSCOPY]: {
    [TECHNICAL_EQUIPMENT_COLONOSCOPY]: "colonoscopy",
    [TECHNICAL_EQUIPMENT_ENDOSCOPIC_ULTRASOUND]: "endoscopicUltrasound",
    [TECHNICAL_EQUIPMENT_ERCP]: "ercp",
    [TECHNICAL_EQUIPMENT_GASTROSCOPY]: "gastroscopy",
  },
  [ONTOLOGIES.ACADEMIC_TITLE]: {
    [ACADEMIC_TITLE_DOCTOR]: "doctor",
    [ACADEMIC_TITLE_DOCTOR_DOCTOR_MEDICINE]: "doctorDoctorMedicine",
    [ACADEMIC_TITLE_DOCTOR_MEDICINE]: "doctorMedicine",
    [ACADEMIC_TITLE_DOCTOR_MULTIPLEX]: "doctorMultiplex",
    [ACADEMIC_TITLE_PROFESSOR]: "professor",
    [ACADEMIC_TITLE_PROFESSOR_DOCTOR]: "professorDoctor",
    [ACADEMIC_TITLE_PROFESSOR_ORDINARIUS]: "professorOrdinarius",
  },
  [ONTOLOGIES.ACCOUNT_ROLE]: {
    [ACCOUNT_ROLE_ADMIN]: "admin",
    [ACCOUNT_ROLE_ADMIN_EDIT_CAREPROVIDER]: "adminEditCareprovider",
    [ACCOUNT_ROLE_ADMIN_EDIT_CARESEEKER]: "adminEditCareseeker",
    [ACCOUNT_ROLE_ADMIN_EDIT_CONSULTANT]: "adminEditConsultants",
    [ACCOUNT_ROLE_ADMIN_READ_ONLY]: "adminReadOnly",
    [ACCOUNT_ROLE_ADMIN_TRANSLATIONS]: "adminTranslations",
    [ACCOUNT_ROLE_CARESEEKER_CARE]: "care",
    [ACCOUNT_ROLE_CARESEEKER_HOSPITALIZATION]: "hospital",
    [ACCOUNT_ROLE_CARESEEKER_PSYCHIATRIC_CARE]: "psychiatricCare",
    [ACCOUNT_ROLE_CARESEEKER_REHAB]: "rehab",
    [ACCOUNT_ROLE_CARESEEKER_USER_MANAGEMENT]: "careseekerUserManagement",
    [ACCOUNT_ROLE_CLINICAL_DOCUMENTATION]: "clinicalDocumentation",
    [ACCOUNT_ROLE_DTA_APPROVER]: "doctor",
    [ACCOUNT_ROLE_MEDICAL_SUPPLIES]: "medicalSupplies",
    [ACCOUNT_ROLE_PREDICT]: "predict",
    [ACCOUNT_ROLE_RECEIVER_ADMISSIONS]: "admissions",
    [ACCOUNT_ROLE_RECEIVER_ANALYTICS]: "analytics",
    [ACCOUNT_ROLE_RECEIVER_BASE_ROLE]: "provider",
    [ACCOUNT_ROLE_RECEIVER_CONTACT]: "providerContact",
    [ACCOUNT_ROLE_REPORT]: "report",
    [ACCOUNT_ROLE_SCRIBE]: "scribe",
    [ACCOUNT_ROLE_SENDER_API_CREATE_PATIENT]: "senderApi",
    [ACCOUNT_ROLE_SENDER_IT]: "it",
    [ACCOUNT_ROLE_VOICE]: "voice",
  },
  [ONTOLOGIES.ACCOUNT_ROLE_SHORT]: {
    [ACCOUNT_ROLE_ADMIN]: "admin",
    [ACCOUNT_ROLE_ADMIN_EDIT_CAREPROVIDER]: "adminEditCareprovider",
    [ACCOUNT_ROLE_ADMIN_EDIT_CARESEEKER]: "adminEditCareseeker",
    [ACCOUNT_ROLE_ADMIN_EDIT_CONSULTANT]: "adminEditConsultants",
    [ACCOUNT_ROLE_ADMIN_READ_ONLY]: "adminReadOnly",
    [ACCOUNT_ROLE_ADMIN_TRANSLATIONS]: "adminTranslations",
    [ACCOUNT_ROLE_CARESEEKER_CARE]: "care",
    [ACCOUNT_ROLE_CARESEEKER_HOSPITALIZATION]: "hospital",
    [ACCOUNT_ROLE_CARESEEKER_PSYCHIATRIC_CARE]: "psychiatricCare",
    [ACCOUNT_ROLE_CARESEEKER_REHAB]: "rehab",
    [ACCOUNT_ROLE_CARESEEKER_USER_MANAGEMENT]: "careseekerUserManagement",
    [ACCOUNT_ROLE_CLINICAL_DOCUMENTATION]: "clinicalDocumentation",
    [ACCOUNT_ROLE_DTA_APPROVER]: "doctor",
    [ACCOUNT_ROLE_MEDICAL_SUPPLIES]: "medicalSupplies",
    [ACCOUNT_ROLE_PREDICT]: "predict",
    [ACCOUNT_ROLE_RECEIVER_ADMISSIONS]: "admissions",
    [ACCOUNT_ROLE_RECEIVER_ANALYTICS]: "analytics",
    [ACCOUNT_ROLE_RECEIVER_BASE_ROLE]: "provider",
    [ACCOUNT_ROLE_RECEIVER_CONTACT]: "providerContact",
    [ACCOUNT_ROLE_REPORT]: "report",
    [ACCOUNT_ROLE_SCRIBE]: "scribe",
    [ACCOUNT_ROLE_SENDER_API_CREATE_PATIENT]: "senderApi",
    [ACCOUNT_ROLE_SENDER_IT]: "it",
    [ACCOUNT_ROLE_VOICE]: "voice",
  },
  [ONTOLOGIES.ACCOUNT_STATUS]: {
    [ACCOUNT_STATUS_ACTIVE]: "active",
    [ACCOUNT_STATUS_CREATED]: "created",
    [ACCOUNT_STATUS_INACTIVE]: "inactive",
  },
  [ONTOLOGIES.ACCOUNT_TYPE]: {
    [ACCOUNT_TYPE_API]: "api",
    [ACCOUNT_TYPE_EXTERNAL]: "external",
    [ACCOUNT_TYPE_PROVIDER_SEARCH]: "bToC",
    [ACCOUNT_TYPE_STAFF]: "staff",
    [ACCOUNT_TYPE_TOOL]: "tool",
  },
  [ONTOLOGIES.ADMISSIONS_FORM_SOLUTIONS]: {
    [ADMISSIONS_FORM_SOLUTIONS.LONG_TERM]: "longTerm",
    [ADMISSIONS_FORM_SOLUTIONS.OTHER]: "other",
    [ADMISSIONS_FORM_SOLUTIONS.SHORT_TERM]: "shortTerm",
  },
  [ONTOLOGIES.ADMISSIONS_MENTAL_ABILITY]: {
    [MENTAL_ABILITY.DEMENT]: "dementia",
    [MENTAL_ABILITY.FULLY_ORIENTED]: "fullyOriented",
    [MENTAL_ABILITY.IMPAIRED]: "limitedCognitiveAbilities",
  },
  [ONTOLOGIES.ADMISSIONS_MOBILITY]: {
    [MOBILITY.BEDRIDDEN]: "bedridden",
    [MOBILITY.FULLY_MOBILE]: "fullyMobile",
    [MOBILITY.NEEDS_SUPPORT]: "needsSupport",
    [MOBILITY.WALKING_AID]: "walkingAssistance",
    [MOBILITY.WHEELCHAIR]: "wheelchair",
  },
  [ONTOLOGIES.AGE_OF_PATIENT]: {},
  [ONTOLOGIES.BLACKLIST_RECEIVER_RULES]: {
    [FILTER_AGE]: "age",
    [FILTER_BLACKLISTED_INSURANCE]: "blacklistedInsurance",
    [FILTER_CAPACITY_BACKOFF]: "capacityBackoff",
    [FILTER_CAPACITY_START_DATE]: "capacityStartDate",
    [FILTER_CONTACTED]: "filterContacted",
    [FILTER_DISTANCE]: "distance",
    [FILTER_NO_BED_AVAILABLE]: "noBedAvailable",
    [FILTER_PREREQUISITE]: "prerequisite",
    [FILTER_RECEIVER_BLACKLISTED]: "receiverBlacklisted",
    [FILTER_REMOVED_SOLUTION]: "removedSolution",
    [FILTER_SENDER_BLACKLISTED]: "senderBlacklisted",
    [FILTER_SERVICE]: "service",
    [FILTER_SOLUTION]: "solution",
    [FILTER_SPECIALIZATION]: "specialization",
    [FILTER_STATUS]: "status",
    [FILTER_THROTTLE]: "throttle",
    [FILTER_ZIPCODES]: "zipcodes",
  },
  [ONTOLOGIES.CANDIDATES_STATUS]: {
    [CANDIDATES_STATUS_FAILED]: "failed",
    [CANDIDATES_STATUS_NOT_STARTED]: "notStarted",
    [CANDIDATES_STATUS_PENDING]: "inProgress",
    [CANDIDATES_STATUS_SUCCESS]: "success",
  },
  [ONTOLOGIES.CARE_DURATIONS]: {
    [CARE_DURATION_FIVE_MONTHS]: "fiveMonths",
    [CARE_DURATION_FOUR_MONTHS]: "fourMonths",
    [CARE_DURATION_ONE_DAY]: "oneDay",
    [CARE_DURATION_ONE_MONTH]: "oneMonth",
    [CARE_DURATION_ONE_WEEK]: "oneWeek",
    [CARE_DURATION_SIX_MONTHS_PLUS]: "sixMonthsPlus",
    [CARE_DURATION_THREE_MONTHS]: "threeMonths",
    [CARE_DURATION_THREE_WEEKS]: "threeWeeks",
    [CARE_DURATION_TWO_MONTHS]: "twoMonths",
    [CARE_DURATION_TWO_WEEKS]: "twoWeeks",
    [CARE_DURATION_UNKNOWN]: "unknown",
  },
  [ONTOLOGIES.CARE_FREQUENCY]: {
    [CARE_FREQUENCY.DAILY]: "daily",
    [CARE_FREQUENCY.DONT_KNOW]: "unknown",
    [CARE_FREQUENCY.WEEKLY]: "weekly",
  },
  [ONTOLOGIES.CARE_LEVEL]: {
    [CARE_LEVELS.FIVE]: "five",
    [CARE_LEVELS.FOUR]: "four",
    [CARE_LEVELS.NONE]: "none",
    [CARE_LEVELS.ONE]: "one",
    [CARE_LEVELS.THREE]: "three",
    [CARE_LEVELS.TWO]: "two",
    [CARE_LEVELS.UNKNOWN]: "unknown",
  },
  [ONTOLOGIES.CAREPROVIDER_STATUS]: {
    [CAREPROVIDER_ACTIVE]: "active",
    [CAREPROVIDER_CREATED]: "created",
    [CAREPROVIDER_DUPLICATE]: "duplicate",
    [CAREPROVIDER_INACTIVE]: "inactive",
    [CAREPROVIDER_INVALID]: "invalid",
    [CAREPROVIDER_PENDING_ACCOUNT_ACTIVATION]: "pendingAccountActivation",
    [CAREPROVIDER_TRASH]: "trash",
  },
  [ONTOLOGIES.CARESEEKER_MODULE_STATUS]: {
    [CARESEEKER_STATUS_ACTIVE]: "active",
    [CARESEEKER_STATUS_CREATED]: "created",
    [CARESEEKER_STATUS_INACTIVE]: "inactive",
    [CARESEEKER_STATUS_ONBOARDING]: "onboarding",
  },
  [ONTOLOGIES.CARESEEKER_PRIORITY]: {},
  [ONTOLOGIES.CARESEEKER_STATUS]: {
    [CARESEEKER_STATUS_ACTIVE]: "active",
    [CARESEEKER_STATUS_DUPLICATE]: "duplicate",
    [CARESEEKER_STATUS_INACTIVE]: "inactive",
    [CARESEEKER_STATUS_SALES]: "salesa",
    [CARESEEKER_STATUS_TRASH]: "trash",
  },
  [ONTOLOGIES.COMMUNICATION]: {
    [COMMUNICATION_BAD]: "bad",
    [COMMUNICATION_GOOD]: "good",
    [COMMUNICATION_MODERATE]: "moderate",
  },
  [ONTOLOGIES.COMPANY_STATUS]: {
    [COMPANY_STATUSES.COMPANY_STATUS_CREATED]: "created",
    [COMPANY_STATUSES.COMPANY_STATUS_DUPLICATE]: "duplicate",
    [COMPANY_STATUSES.COMPANY_STATUS_INACTIVE]: "no",
  },
  [ONTOLOGIES.COMPANY_TYPE]: {
    [COMPANY_TYPES.COMPANY_TYPE_FACILITY]: "facility",
    [COMPANY_TYPES.COMPANY_TYPE_ORGANIZATION]: "organization",
  },
  [ONTOLOGIES.COMPRESSION_TYPE]: {},
  [ONTOLOGIES.CONFESSION]: {},
  [ONTOLOGIES.CONSCIOUSNESS]: {
    [CONSCIOUSNESS_COMATOSE]: "coma",
    [CONSCIOUSNESS_DROWSY]: "dazed",
    [CONSCIOUSNESS_LUCID]: "clear",
    [CONSCIOUSNESS_QUALITATIVE_DISTURBANCE]:
      "qualitativeReductionConsciousness",
    [CONSCIOUSNESS_QUANTITATIVE_REDUCTION]:
      "quantitativeReductionConsciousness",
    [CONSCIOUSNESS_SOMNOLENT]: "somnolent",
    [CONSCIOUSNESS_SOPOROUS]: "sopor",
  },
  [ONTOLOGIES.CONSULTANT_STATUS]: {
    [CONSULTANT_STATUS_ACTIVE]: "active",
    [CONSULTANT_STATUS_CREATED]: "created",
    [CONSULTANT_STATUS_INACTIVE]: "inactive",
  },
  [ONTOLOGIES.CONTACT_BEHAVIOUR]: {
    [CONTACT_BEHAVIOUR_COOPERATIVE]: "cooperative",
    [CONTACT_BEHAVIOUR_MOSTLY_COOPERATIVE]: "mostlyCooperative",
    [CONTACT_BEHAVIOUR_SEVERELY_LIMITED]: "severelyLimited",
    [CONTACT_BEHAVIOUR_UNSTABLE]: "unstable",
  },
  [ONTOLOGIES.CURRENT_CARE]: {
    [CURRENT_CARE_BASE_TYPES.BY_RELATIVES]: "byRelatives",
    [CURRENT_CARE_BASE_TYPES.FACILITY]: "facility",
    [CURRENT_CARE_BASE_TYPES.MOBILE]: "mobile",
    [CURRENT_CARE_BASE_TYPES.NONE]: "none",
  },
  [ONTOLOGIES.CURRENT_CARE_FACILITY_TYPES]: {
    [CURRENT_CARE_FACILITY_TYPES.ASSISTED_LIVING]: "assistedLiving",
    [CURRENT_CARE_FACILITY_TYPES.OTHER]: "other",
    [CURRENT_CARE_FACILITY_TYPES.SHORT_TERM]: "shortTerm",
    [CURRENT_CARE_FACILITY_TYPES.STATIC_CARE]: "staticCare",
  },
  [ONTOLOGIES.DAILY_STRUCTURE]: {
    [DAILY_STRUCTURE_IRREGULAR_ATTENDANCE]: "irregularAttendance",
    [DAILY_STRUCTURE_NO_PARTICIPATION]: "noParticipation",
    [DAILY_STRUCTURE_PARTICIPATES_PREDOMINANTLY]: "participatesPredominantly",
    [DAILY_STRUCTURE_PARTICIPATES_RELIABLY]: "participatesReliably",
  },
  [ONTOLOGIES.DECLINED_REASON]: {},
  [ONTOLOGIES.DEMENTIA]: {
    [DEMENTIA_NO]: "no",
    [DEMENTIA_UNKNOWN]: "unknown",
    [DEMENTIA_YES]: "yes",
  },
  [ONTOLOGIES.DEPENDENCY_LEVEL]: {},
  [ONTOLOGIES.DIRECT_REQUEST_TYPES]: {
    [AUCTION_REQUEST_ORIGIN.ADMISSIONS_CAREPROVIDER]:
      "admissionsManuallyCreated",
    [AUCTION_REQUEST_ORIGIN.ADMISSIONS_DIRECT]: "admissionsForm",
    [AUCTION_REQUEST_ORIGIN.PROVIDER_SEARCH]: "providerSearch",
    [AUCTION_REQUEST_ORIGIN.SENDER]: "clinic",
  },
  [ONTOLOGIES.ELIGIBILITY_REJECT_REASON]: {
    [ELIGIBILITY_REJECT_ANOTHER_FORM_OF_REHAB_SOUGHT]: "anotherFormRehaSought",
    [ELIGIBILITY_REJECT_DIFFERENT_COST_PAYER_RESPONSIBLE]:
      "differentCostPayerResponsible",
    [ELIGIBILITY_REJECT_NOT_ELIGIBLE]: "patientNotEligible",
    [ELIGIBILITY_REJECT_OTHER]: "otherReason",
  },
  [ONTOLOGIES.EMAIL_TYPE]: {
    [MAIL_TYPES.ATTRIBUTION_CANCELLATION]: "attributionCancellation",
    [MAIL_TYPES.ATTRIBUTION_CONFIRMATION]: "attributionConfirmation",
    [MAIL_TYPES.AUCTION_REQUEST]: "auctionRequest",
    [MAIL_TYPES.CAREPROVIDER_ACCOUNT_ADDED]: "accountAdded",
    [MAIL_TYPES.CAREPROVIDER_ACCOUNT_INVITATION]: "accountInvited",
    [MAIL_TYPES.NEW_ANSWER]: "newAnswer",
    [MAIL_TYPES.NEW_FILE_FROM_CLINIC]: "newMessageFromClinic",
    [MAIL_TYPES.ONBOARDING]: "onboarding",
    [MAIL_TYPES.PASSWORD_CHANGED]: "passwordChanged",
    [MAIL_TYPES.PATIENT_UNAVAILABLE]: "receiverRejected",
    [MAIL_TYPES.PROFILE_EDITED_NOTIFICATION]: "profileEdited",
    [MAIL_TYPES.RESET_PASSWORD]: "resetPassword",
    [MAIL_TYPES.SEARCH_REMINDER]: "searchReminder",
    [MAIL_TYPES.SOCIAL_WORKER_ASSIGNED]: "assigneeChanged",
    [MAIL_TYPES.WELCOME]: "welcomeEmail",
  },
  [ONTOLOGIES.EMPLOYMENT_STATUS]: {
    [EMPLOYMENT_STATUS_CIVIL_SERVANT]: "civilServant",
    [EMPLOYMENT_STATUS_EMPLOYEE]: "employee",
    [EMPLOYMENT_STATUS_MASTER_FOREMAN]: "masterForeman",
    [EMPLOYMENT_STATUS_NOT_EMPLOYED]: "notEmployed",
    [EMPLOYMENT_STATUS_SELF_EMPLOYED]: "selfEmployed",
    [EMPLOYMENT_STATUS_SEMI_SKILLED_WORKER]: "semiSkilledWorker",
    [EMPLOYMENT_STATUS_SKILLED_WORKER]: "skilledWorker",
    [EMPLOYMENT_STATUS_TRAINEE]: "trainee",
    [EMPLOYMENT_STATUS_UNSKILLED_EMPLOYEE]: "unskilledEmployee",
  },
  [ONTOLOGIES.ENDANGERMENT_OF_OTHERS]: {
    [ENDANGERMENT_OF_OTHERS_NO]: "no",
    [ENDANGERMENT_OF_OTHERS_UNKNOWN]: "unknown",
    [ENDANGERMENT_OF_OTHERS_YES]: "yes",
  },
  [ONTOLOGIES.FACILITY]: {
    [FACILITY_ASSISTED_LIVING]: "assistedLiving",
    [FACILITY_COMPANIONSHIP]: "companionship",
    [FACILITY_DAILY_LIVING_SUPPORT_SERVICES]: "dailyLivingSupportServices",
    [FACILITY_DAY_CARE]: "dayCare",
    [FACILITY_DAY_HOSPITALIZATION]: "dayHospitalization",
    [FACILITY_FULL_HOSPITALIZATION]: "fullHospitalization",
    [FACILITY_FULLTIME_COMPANIONSHIP]: "fullTimeCompanionship",
    [FACILITY_FULLTIME_MOBILE_CARE]: "fullTimeMobileCare",
    [FACILITY_HOME_CARE]: "medicalSuppliesHomeCare",
    [FACILITY_HOSPICE_ASSOCIATION]: "hospice",
    [FACILITY_HOSPICE_MOBILE]: "hospiceMobile",
    [FACILITY_HOSPICE_PARTIALLY_MOBILE]: "hospicePartiallyMobile",
    [FACILITY_HOSPICE_STATIC]: "hospiceStatic",
    [FACILITY_MEDICAL_SUPPLIES]: "medicalSupplies",
    [FACILITY_MOBILE_CARE]: "mobileCare",
    [FACILITY_NIGHT_CARE_MOBILE]: "nightCareMobile",
    [FACILITY_NIGHT_CARE_STATIC]: "nightCareStatic",
    [FACILITY_PURE_INTENSIVE_CARE]: "pureIntensiveCare",
    [FACILITY_REHAB_DAY_HOSPITALIZATION]: "rehabDayHospitalization",
    [FACILITY_REHAB_FULL_HOSPITALIZATION]: "rehabFullHospitalization",
    [FACILITY_REHAB_MOBILE]: "rehabMobile",
    [FACILITY_SHARED_FLAT]: "sharedFlat",
    [FACILITY_SHORT_TERM_CARE]: "shortTermStaticCare",
    [FACILITY_STATIC_CARE]: "staticCare",
  },
  [ONTOLOGIES.FILE_CATEGORY]: {
    [FILE_CATEGORY_AD]: "ad",
    [FILE_CATEGORY_AND]: "and",
    [FILE_CATEGORY_APF]: "apf",
    [FILE_CATEGORY_BIX]: "bix",
    [FILE_CATEGORY_CC]: "cc",
    [FILE_CATEGORY_CTB]: "ctb",
    [FILE_CATEGORY_FSO]: "fso",
    [FILE_CATEGORY_GI]: "gi",
    [FILE_CATEGORY_ISO]: "iso",
    [FILE_CATEGORY_MDL]: "mdl",
    [FILE_CATEGORY_MP]: "mp",
    [FILE_CATEGORY_MR]: "mr",
    [FILE_CATEGORY_MSR]: "msr",
    [FILE_CATEGORY_PR]: "pr",
    [FILE_CATEGORY_PRE]: "pre",
    [FILE_CATEGORY_RBA]: "rba",
    [FILE_CATEGORY_RER]: "rer",
    [FILE_CATEGORY_TRC]: "trc",
    [FILE_CATEGORY_WP]: "wp",
  },
  [ONTOLOGIES.FILE_ERROR]: {
    [FILE_ERROR_FILE_SIZE]: "fileSize",
    [FILE_ERROR_FILE_TYPE]: "fileType",
  },
  [ONTOLOGIES.FILE_SHARE_MODE]: {
    [FILE_SHARE_MODE_ALL]: "all",
    [FILE_SHARE_MODE_NONE]: "none",
    [FILE_SHARE_MODE_SELECTED]: "selected",
  },
  [ONTOLOGIES.FOOD_HELP]: {},
  [ONTOLOGIES.FORM_YES_NO]: {
    [FORM_YES_NO_NEGATIVE]: "no",
    [FORM_YES_NO_POSITIVE]: "yes",
  },
  [ONTOLOGIES.GENDER]: {
    [GENDER.DIVERSE]: "diverse",
    [GENDER.FEMALE]: "female",
    [GENDER.MALE]: "male",
  },
  // to be deprecated on release of new rehab forms
  [ONTOLOGIES.GENDER_EXTENDED]: {
    [GENDER.DIVERSE]: "diverse",
    [GENDER.FEMALE]: "female",
    [GENDER.MALE]: "male",
    [GENDER.UNSPECIFIED]: "withoutEntry",
  },
  [ONTOLOGIES.GENDER_LETTER]: {},
  [ONTOLOGIES.GRANT_STATUS]: {
    [GRANT_STATUS_APPLIED_FOR]: "applied",
    [GRANT_STATUS_EXISTS]: "exists",
    [GRANT_STATUS_NOT_APPLIED]: "notApplied",
  },
  [ONTOLOGIES.GRANTS_TYPE]: {
    [GRANTS_COMBINATION_OF_BOTH]: "combinationOfBoth",
    [GRANTS_MONEY_FROM_INSURANCE]: "serviceBasedPayout",
    [GRANTS_MONEY_FROM_STATE]: "fixedPayout",
  },

  [ONTOLOGIES.GUARDIAN_TYPE]: {
    [GUARDIAN.CARER]: "carer",
    [GUARDIAN.HEALTH_CARE_REP]: "healthCareRepresentative",
    [GUARDIAN.LEGAL_REP]: "legalRepresentative",
    [GUARDIAN.SPOUSAL_EMERGENCY_REP]: "spousalEmergencyRepresentative",
  },
  [ONTOLOGIES.IDENTITY_PROVIDER_TYPE]: {
    [IDENTITY_PROVIDER_TYPE.GOOGLE]: "google",
    [IDENTITY_PROVIDER_TYPE.MICROSOFT]: "microsoft",
    [IDENTITY_PROVIDER_TYPE.OKTA]: "okta",
    [IDENTITY_PROVIDER_TYPE.WSO]: "wso",
  },
  [ONTOLOGIES.IMAGERY]: {
    [TECHNICAL_EQUIPMENT_CTSCAN]: "ctScan",
    [TECHNICAL_EQUIPMENT_DOPPLERS]: "dopplers",
    [TECHNICAL_EQUIPMENT_INTERVENTION_RADIOLOGY]: "interventionalRadiology",
    [TECHNICAL_EQUIPMENT_MRI]: "mri",
    [TECHNICAL_EQUIPMENT_ULTRASOUND]: "ultrasound",
    [TECHNICAL_EQUIPMENT_XRAY]: "xRay",
  },
  [ONTOLOGIES.INCONTINENCE_HELP_TYPE]: {},
  [ONTOLOGIES.INFECTION_AND_GERMS]: {
    [INFECTION_AND_GERMS_REQUIRES_CLOSTRIDIEN]: "clostridien",
    [INFECTION_AND_GERMS_REQUIRES_FOUR_MRGN]: "four_mrgn",
    [INFECTION_AND_GERMS_REQUIRES_ISOLATION]: "requires_isolation",
    [INFECTION_AND_GERMS_REQUIRES_MRSA]: "mrsa",
    [INFECTION_AND_GERMS_REQUIRES_THREE_MRGN]: "three_mrgn",
    [INFECTION_AND_GERMS_REQUIRES_VRE]: "vre",
  },
  [ONTOLOGIES.INFORMATION_SYSTEM]: {
    [INF_SYS_CONNEXT_VIVENDI]: "connextVivendi",
    [INF_SYS_CURASOFT]: "curasoft",
    [INF_SYS_DAN_PRODUKTE]: "danProdukte",
    [INF_SYS_GODO_SYSTEMS]: "godoSystems",
    [INF_SYS_MEDIFOX]: "medifox",
    [INF_SYS_MYNEVA]: "myneva",
    [INF_SYS_NOVENTI_CARE]: "noventiCare",
    [INF_SYS_OTHER]: "other",
    [INF_SYS_SENSO]: "senso",
    [INF_SYS_SINFONIE]: "sinfonie",
    [INF_SYS_SNAP]: "snap",
  },
  [ONTOLOGIES.INJECTION_TYPE]: {},
  [ONTOLOGIES.INSURANCE_TYPE]: {
    [COST_PAYER_TYPE_PRIVATE_HEALTH_INSURANCE]: "private",
    [COST_PAYER_TYPE_PUBLIC_HEALTH_INSURANCE]: "public",
  },
  [ONTOLOGIES.INVOICE_STATUS]: {},
  [ONTOLOGIES.INVOICE_TYPE]: {},
  [ONTOLOGIES.LANGUAGE]: {
    [LANGUAGE_AFGHAN]: "afghan",
    [LANGUAGE_ALBANIAN]: "albanian",
    [LANGUAGE_AMHARIC]: "amharic",
    [LANGUAGE_ARABIC]: "arabic",
    [LANGUAGE_AZERBAIJANI]: "azerbaijani",
    [LANGUAGE_BENGAL]: "bengal",
    [LANGUAGE_BOSNIAN]: "bosnian",
    [LANGUAGE_BULGARIAN]: "bulgarian",
    [LANGUAGE_CANTONESE]: "cantonese",
    [LANGUAGE_CROATIAN]: "croatian",
    [LANGUAGE_CZECH]: "czech",
    [LANGUAGE_DANISH]: "danish",
    [LANGUAGE_DUTCH]: "dutch",
    [LANGUAGE_ENGLISH]: "english",
    [LANGUAGE_FINNISH]: "finnish",
    [LANGUAGE_FRENCH]: "french",
    [LANGUAGE_GEORGIAN]: "georgian",
    [LANGUAGE_GERMAN]: "german",
    [LANGUAGE_GREEK]: "greek",
    [LANGUAGE_HEBREW]: "hebrew",
    [LANGUAGE_HINDI]: "hindi",
    [LANGUAGE_HUNGARIAN]: "hungarian",
    [LANGUAGE_INDONESIAN]: "indonesian",
    [LANGUAGE_ITALIAN]: "italian",
    [LANGUAGE_JAPANESE]: "japanese",
    [LANGUAGE_KOREAN]: "korean",
    [LANGUAGE_KURDISH]: "kurdish",
    [LANGUAGE_LITHUNIAN]: "lithuanian",
    [LANGUAGE_MANDARIN]: "mandarin",
    [LANGUAGE_NORWEGIAN]: "norwegian",
    [LANGUAGE_PERSIAN]: "persian",
    [LANGUAGE_POLISH]: "polish",
    [LANGUAGE_PORTUGUESE]: "portuguese",
    [LANGUAGE_ROMANIAN]: "romanian",
    [LANGUAGE_RUSSIAN]: "russian",
    [LANGUAGE_SERBIAN]: "serbian",
    [LANGUAGE_SIGN]: "sign",
    [LANGUAGE_SPANISH]: "spanish",
    [LANGUAGE_SWAHILI]: "swahili",
    [LANGUAGE_SWEDISH]: "swedish",
    [LANGUAGE_THAI]: "thai",
    [LANGUAGE_TIGRINYA]: "tigrinya",
    [LANGUAGE_TURKISH]: "turkish",
    [LANGUAGE_URDU]: "urdu",
    [LANGUAGE_URKRAINIAN]: "ukrainian",
    [LANGUAGE_VIETNAMESE]: "vietnamese",
  },
  [ONTOLOGIES.LIVING_SITUATION]: {
    [LIVING_SITUATION_ALONE]: "livingSituationAlone",
    [LIVING_SITUATION_CAREHOME]: "livingSituationCarehome",
    [LIVING_SITUATION_NO_RESIDENCE]: "livingSituationNoResidence",
    [LIVING_SITUATION_OTHER]: "livingSituationOther",
    [LIVING_SITUATION_SHARED_FLAT]: "livingSituationSharedFlat",
    [LIVING_SITUATION_WITH_FAMILY]: "livingSituationWithFamily",
  },
  [ONTOLOGIES.MARITAL_STATUS]: {
    [MARITAL_STATUS.DIVORCED]: "divorced",
    [MARITAL_STATUS.MARRIED]: "married",
    [MARITAL_STATUS.SINGLE]: "single",
    [MARITAL_STATUS.WIDOWED]: "widowed",
  },
  [ONTOLOGIES.MEALS]: {},
  [ONTOLOGIES.MENTAL_HEALTH_COMMUNICATION]: {},
  [ONTOLOGIES.MOBILITY]: {
    [MOBILITY_CRUTCH]: "crutch",
    [MOBILITY_MEDICALISED_BED]: "medicalisedBed",
    [MOBILITY_ROLLATOR]: "rollator",
    [MOBILITY_WALK_WITH_HELP]: "walkWithHelp",
    [MOBILITY_WALK_WITHOUT_HELP]: "walkWithoutHelp",
    [MOBILITY_WALKING_FRAME]: "walkingFrame",
    [MOBILITY_WALKING_STICK]: "walkingStick",
    [MOBILITY_WHEELCHAIR]: "wheelChair",
  },
  [ONTOLOGIES.MOTIVATION]: {
    [MOTIVATION_BAD]: "bad",
    [MOTIVATION_GOOD]: "good",
    [MOTIVATION_MODERATE]: "moderate",
  },
  [ONTOLOGIES.MOTIVATION_PATIENT]: {
    [MOTIVATION_PATIENT_LOW]: "lowMotivation",
    [MOTIVATION_PATIENT_MOTIVATED]: "motivated",
    [MOTIVATION_PATIENT_NO_MOTIVATION]: "noMotivation",
    [MOTIVATION_PATIENT_SUFFICIENT]: "sufficientMotivation",
  },
  [ONTOLOGIES.ONBOARDING_STATUS]: {
    [ONBOARDING_ADMINISTRATION_PHASE]: "administrationPhase",
    [ONBOARDING_CHAIN]: "chain",
    [ONBOARDING_CONSIDERATION_PHASE]: "considerationPhase",
    [ONBOARDING_INFO_PHASE]: "infoPhase",
    [ONBOARDING_MANUALLY_ADDED_BY_SENDER]: "manuallyAdded",
    [ONBOARDING_MISSING_INFORMATION]: "missingInformation",
    [ONBOARDING_PREONBOARDING]: "preOnboarding",
    [ONBOARDING_SELF_ONBOARDING]: "selfOnboarding",
    [ONBOARDING_TO_CALL]: "toCall",
  },
  [ONTOLOGIES.ORIENTATION]: {
    [ORIENTATION_DISORIENTED]: "disoriented",
    [ORIENTATION_LIMITED]: "limited",
    [ORIENTATION_ORIENTATED]: "orientated",
  },
  [ONTOLOGIES.PAGINATION_RESULT_COUNT]: {
    [PAGINATION_COUNT_10]: "ten",
    [PAGINATION_COUNT_20]: "twenty",
    [PAGINATION_COUNT_30]: "thirty",
  },
  [ONTOLOGIES.PATIENT_TYPE]: {
    [SEARCH_TYPE_CARE]: "care",
    [SEARCH_TYPE_HOME_CARE]: "homeCare",
    [SEARCH_TYPE_HOSPITAL]: "hospital",
    [SEARCH_TYPE_MEDICAL_SUPPLIES]: "medicalSupplies",
    [SEARCH_TYPE_PSYCHIATRIC_CARE]: "psychiatricCare",
    [SEARCH_TYPE_REHABILITATION]: "rehab",
  },
  [ONTOLOGIES.POSITION]: {},
  [ONTOLOGIES.PRIOR_EMPLOYMENT_STATUS]: {
    [PRIOR_EMPLOYMENT_STATUS.FULL_TIME_NO_ROTATING_SHIFT]: "fullTimeWithShifts",
    [PRIOR_EMPLOYMENT_STATUS.FULL_TIME_ROTATING_SHIFT]: "fullTimeNoShifts",
    [PRIOR_EMPLOYMENT_STATUS.HOUSEHOLD_CARE]: "householdCare",
    [PRIOR_EMPLOYMENT_STATUS.NOT_WORKING]: "notWorking",
    [PRIOR_EMPLOYMENT_STATUS.PART_TIME_LESS_THAN_HALF_DAY]:
      "partTimeLessThanHalfDay",
    [PRIOR_EMPLOYMENT_STATUS.PART_TIME_MORE_THAN_HALF_DAY]:
      "partTimeMoreThanHalfDay",
    [PRIOR_EMPLOYMENT_STATUS.UNEMPLOYED_REGISTERED]: "notEmployedRegistered",
    [PRIOR_EMPLOYMENT_STATUS.WITH_NIGHT_SHIFTS]: "wihtNightShifts",
    [PRIOR_EMPLOYMENT_STATUS.WORK_AT_HOME]: "workAtHome",
    [PRIOR_EMPLOYMENT_STATUS.WORKSHOP_FOR_DISABLED_PEOPLE]:
      "workshopForDisabledPeople",
  },
  [ONTOLOGIES.PRODUCT_FEATURE]: {
    [PRODUCT_FEATURES.ADMISSIONS]: "recareAdmissions",
    [PRODUCT_FEATURES.AI_CHAT]: "aiChat",
    [PRODUCT_FEATURES.ANALYTICS]: "recareAnalytics",
    [PRODUCT_FEATURES.DISCHARGE_LETTER]: "dischargeLetter",
    [PRODUCT_FEATURES.DOCS_AND_EXTRACT]: "docsAndExtract",
    [PRODUCT_FEATURES.DTA]: "dta",
    [PRODUCT_FEATURES.PREDICT]: "recarePredict",
    [PRODUCT_FEATURES.SCRIBE]: "recareScribe",
    [PRODUCT_FEATURES.TRANSITIONAL_CARE]: "transitionalCare",
    [PRODUCT_FEATURES.VOICE]: "recareVoice",
  },
  [ONTOLOGIES.PROVIDER_SEARCH_NAV_TITLE]: {
    [PROVIDER_SEARCH_BAVARIA]: "bavaria",
  },
  [ONTOLOGIES.PROVIDER_SEARCH_REQUEST_STATUS]: {
    [AUCTION_REQUEST_ACCEPTED]: "accepted",
    [AUCTION_REQUEST_ATTRIBUTED]: "attributed",
    [AUCTION_REQUEST_CREATED]: "created",
    [AUCTION_REQUEST_DECLINED]: "declined",
    [AUCTION_REQUEST_REJECTED]: "rejected",
    [AUCTION_REQUEST_SENT]: "sent",
    [AUCTION_REQUEST_UNAVAILABLE]: "unavailable",
  },
  [ONTOLOGIES.RECEIVER_INACTIVE_REASON]: {
    [RECEIVER_INACTIVE_REASONS.ASKLEPIOS_INHOUSE_SOLUTION]:
      "asklepiosInhouseSolution",
    [RECEIVER_INACTIVE_REASONS.CHURNED]: "churned",
    [RECEIVER_INACTIVE_REASONS.CLOSED]: "closed",
    [RECEIVER_INACTIVE_REASONS.HIGH_LEVEL_DECISION]: "higherLevelDecision",
    [RECEIVER_INACTIVE_REASONS.MEDIAN_INHOUSE_SOLUTION]:
      "medianInhouseSolution",
    [RECEIVER_INACTIVE_REASONS.NEVER_REACHED_AGAIN]: "neverReachedAgain",
    [RECEIVER_INACTIVE_REASONS.NO_ACCOUNT]: "noAccount",
    [RECEIVER_INACTIVE_REASONS.NO_INTEREST_DO_NOT_CONTACT]:
      "noInterestDoNotContact",
    [RECEIVER_INACTIVE_REASONS.NO_INTEREST_MAYBE_LATER]: "noInterestMaybeLater",
    [RECEIVER_INACTIVE_REASONS.TEMPORARY_CLOSED]: "temporaryClosed",
    [RECEIVER_INACTIVE_REASONS.UNNNEEDED_CHAIN_CENTER]: "unneededChainCenter",
    [RECEIVER_INACTIVE_REASONS.UNNNEEDED_CHAIN_SUBSIDIARY]:
      "unneededChainSubsidiary",
    [RECEIVER_INACTIVE_REASONS.UNSUPPORTED_FACILITY]: "unsupportedFacility",
  },
  [ONTOLOGIES.RECEIVER_TYPE_PLURAL]: {
    [SEARCH_TYPE_CARE]: "care",
    [SEARCH_TYPE_HOME_CARE]: "homeCare",
    [SEARCH_TYPE_HOSPITAL]: "hospital",
    [SEARCH_TYPE_MEDICAL_SUPPLIES]: "medicalSupplies",
    [SEARCH_TYPE_REHABILITATION]: "rehab",
  },
  [ONTOLOGIES.RECEIVER_TYPE_PLURAL_PREFERRED]: {
    [SEARCH_TYPE_CARE]: "care",
    [SEARCH_TYPE_HOME_CARE]: "homeCare",
    [SEARCH_TYPE_HOSPITAL]: "hospital",
    [SEARCH_TYPE_MEDICAL_SUPPLIES]: "medicalSupplies",
    [SEARCH_TYPE_REHABILITATION]: "rehab",
  },
  [ONTOLOGIES.RECEIVER_TYPE_SINGULAR]: {
    [SEARCH_TYPE_CARE]: "care",
    [SEARCH_TYPE_HOME_CARE]: "homeCare",
    [SEARCH_TYPE_HOSPITAL]: "hospital",
    [SEARCH_TYPE_MEDICAL_SUPPLIES]: "medicalSupplies",
    [SEARCH_TYPE_REHABILITATION]: "rehab",
  },
  [ONTOLOGIES.RECEIVER_TYPE_SINGULAR_PREFERRED]: {
    [SEARCH_TYPE_CARE]: "care",
    [SEARCH_TYPE_HOME_CARE]: "homeCare",
    [SEARCH_TYPE_HOSPITAL]: "hospital",
    [SEARCH_TYPE_MEDICAL_SUPPLIES]: "medicalSupplies",
    [SEARCH_TYPE_REHABILITATION]: "rehab",
  },
  [ONTOLOGIES.REFERRAL_SOURCE_MOBILE]: {
    [REFERRAL_SOURCE.CONSULTANT]: "consultant",
    [REFERRAL_SOURCE.INTERNET_RESEARCH]: "internetResearch",
    [REFERRAL_SOURCE.MEDICAL_PRACTICE]: "medicalPractice",
    [REFERRAL_SOURCE.ONLINE_PORTALS]: "onlinePortal",
    [REFERRAL_SOURCE.OTHER]: "other",
    [REFERRAL_SOURCE.PROVIDER_PREVIOUSLY_USED]: "previouslyUsed",
    [REFERRAL_SOURCE.PROVIDER_WEBSITE]: "providerWebsite",
    [REFERRAL_SOURCE.RECOMMENDATION]: "recommendations",
  },
  [ONTOLOGIES.REFERRAL_SOURCE_STATIC]: {
    [REFERRAL_SOURCE.CONSULTANT]: "consultant",
    [REFERRAL_SOURCE.INTERNET_RESEARCH]: "internetResearch",
    [REFERRAL_SOURCE.MEDICAL_PRACTICE]: "medicalPractice",
    [REFERRAL_SOURCE.ONLINE_PORTALS]: "onlinePortal",
    [REFERRAL_SOURCE.OTHER]: "other",
    [REFERRAL_SOURCE.PROVIDER_PREVIOUSLY_USED]: "previouslyUsed",
    [REFERRAL_SOURCE.PROVIDER_WEBSITE]: "providerWebsite",
    [REFERRAL_SOURCE.RECOMMENDATION]: "recommendations",
  },
  [ONTOLOGIES.REHABILITATION_POTENTIAL]: {
    [REHABILITATION_POTENTIAL_EVALUATION_EXTREMELY_NEGATIVE]:
      "evaluationExtremelyNegative",
    [REHABILITATION_POTENTIAL_EVALUATION_EXTREMELY_POSITIVE]:
      "evaluationExtremelyPositive",
    [REHABILITATION_POTENTIAL_EVALUATION_MODERATE]: "evaluationModerate",
    [REHABILITATION_POTENTIAL_EVALUATION_NEGATIVE]: "evaluationNegative",
    [REHABILITATION_POTENTIAL_EVALUATION_POSITIVE]: "evaluationPositive",
  },
  [ONTOLOGIES.RELATIONSHIP_TO_PATIENT]: {
    [RELATIONSHIP_TO_PATIENT.CHILD]: "child",
    [RELATIONSHIP_TO_PATIENT.GUARDIAN]: "caretaker",
    [RELATIONSHIP_TO_PATIENT.OTHER]: "other",
    [RELATIONSHIP_TO_PATIENT.PARENT]: "parent",
    [RELATIONSHIP_TO_PATIENT.SPOUSE]: "spouse",
  },
  [ONTOLOGIES.RELIEF_SERVICES]: {
    [RELIEF_SERVICES_PARAGRAPH_A]: "paragraphA",
    [RELIEF_SERVICES_PARAGRAPH_B]: "paragraphB",
  },
  [ONTOLOGIES.REQUIRED_CARE_BASIC_TYPES]: {
    [REQUIRED_CARE_BASIC_TYPES.BASIC_FULL_BODY]: "personalHygieneFull",
    [REQUIRED_CARE_BASIC_TYPES.BASIC_MEAL_PREP]: "meals",
    [REQUIRED_CARE_BASIC_TYPES.BASIC_MINIMAL]: "personalHygiene",
    [REQUIRED_CARE_BASIC_TYPES.BASIC_MOBILITY]: "mobility",
  },
  [ONTOLOGIES.REQUIRED_CARE_TYPES]: {
    [REQUIRED_CARE_TYPES.BASIC]: "basicCare",
    [REQUIRED_CARE_TYPES.DOMESTIC_SUPPORT]: "helpAtHome",
    [REQUIRED_CARE_TYPES.MEDICAL_TREATMENT]: "medicalCare",
    [REQUIRED_CARE_TYPES.OTHER]: "other",
    [REQUIRED_CARE_TYPES.SUPPORT_SERVICES]: "supportServices",
  },
  [ONTOLOGIES.ROOM_TYPE]: {
    [ROOM_TYPES.ACCOMPANYING_CHILD]: "accompanyingChild",
    [ROOM_TYPES.ACCOMPANYING_PERSON]: "accompanyingPerson",
    [ROOM_TYPES.ACCOMPANYING_SIBLING]: "accompanyingSibling",
    [ROOM_TYPES.APARTMENT]: "apartment",
    [ROOM_TYPES.BARRIER_FREE]: "barrierFree",
    [ROOM_TYPES.DOUBLE_ROOM]: "double",
    [ROOM_TYPES.NO_PREFERENCE]: "no_preference",
    [ROOM_TYPES.SINGLE_STANDARD]: "single",
  },
  [ONTOLOGIES.ROWS_PER_PAGE]: {
    [SEARCH_TABLE_ROW_COUNT_10]: "tenRows",
    [SEARCH_TABLE_ROW_COUNT_30]: "thirtyRows",
    [SEARCH_TABLE_ROW_COUNT_50]: "fiftyRows",
  },
  [ONTOLOGIES.SALUTATION]: {
    [GENDER.DIVERSE]: "other",
    [GENDER.FEMALE]: "madame",
    [GENDER.MALE]: "monsieur",
  },
  [ONTOLOGIES.SEARCH_PAGE_TABLE_TITLE]: {},
  [ONTOLOGIES.SEARCH_REASON]: {
    [SEARCH_REASON.HOSIPTAL_DISCHARGE]: "hospitalDischarge",
    [SEARCH_REASON.INCREASED_NEED]: "increasedNeed",
    [SEARCH_REASON.OTHER]: "other",
    [SEARCH_REASON.PROVIDER_CHANGE_REQUIRED]: "providerChangeRequired",
    [SEARCH_REASON.RELATIVES_UNABLE]: "relativesUnable",
  },
  [ONTOLOGIES.SEARCH_TABLE_STATUS_CHIPS]: {
    [REQUEST_CHIP_STATUS_FAX_SENT]: "faxSent",
    [REQUEST_CHIP_STATUS_NEW_FILE]: "newFile",
    [REQUEST_CHIP_STATUS_NEW_MESSAGE]: "newMessage",
    [REQUEST_CHIP_STATUS_ONGOING_CHAT]: "ongoingChat",
    [REQUEST_CHIP_STATUS_PROVIDER_INACTIVE]: "providerInactive",
    [REQUEST_CHIP_STATUS_REQUEST_NOT_SEEN]: "requestNotSeen",
    [REQUEST_CHIP_STATUS_REQUEST_SEEN]: "requestSeen",
    [REQUEST_CHIP_STATUS_SENT_MESSAGE_NOT_SEEN]: "sentMessageNotSeen",
    [REQUEST_CHIP_STATUS_SENT_MESSAGE_SEEN]: "sentMessageSeen",
  },
  [ONTOLOGIES.SELF_ENDANGERMENT]: {
    [SELF_ENDANGERMENT_NO]: "no",
    [SELF_ENDANGERMENT_UNKNOWN]: "unknown",
    [SELF_ENDANGERMENT_YES]: "yes",
  },
  [ONTOLOGIES.SERVICE]: {
    [SERVICE_BASIC_CARE]: "basicCare",
    [SERVICE_BASIC_MEDICAL_CARE]: "basicMedicalCare",
    [SERVICE_CARE_FOR_CHILDREN_AND_TEENAGERS]: "careForChildrenAndTeenagers",
    [SERVICE_CARE_FOR_YOUTH]: "careForYouth",
    [SERVICE_CARE_PROTECTED_AREA]: "protectedAreaCare",
    [SERVICE_CLOSED_AREA]: "closedArea",
    [SERVICE_COMPANIONSHIP]: "companionship",
    [SERVICE_DEMENTIA]: "dementia",
    [SERVICE_DIALYSIS]: "dialysis",
    [SERVICE_ENTERALNUTRITION]: "enteralNutrition",
    [SERVICE_GENERAL_MOBILE_PALLIATIVE_CARE]: "generalMobilePalliative",
    [SERVICE_HEARING_IMPAIRED]: "hearingImpaired",
    [SERVICE_HELPWITHEATING]: "helpWithEating",
    [SERVICE_INTEGRATION_ASSISTANCE]: "integrationAssistance",
    [SERVICE_INVASIVEVENTILATION]: "invasiveVentilation",
    [SERVICE_MONITORINGBREATHING]: "monitoringBreathing",
    [SERVICE_MONITORINGCIRCULATION]: "monitoringCirculation",
    [SERVICE_MONITORINGMETABOLISM]: "monitoringMetabolism",
    [SERVICE_NIGHT_MOBILE_CARE]: "nightMobileCare",
    [SERVICE_NONINVASIVEVENTILATION]: "nonInvasiveVentilation",
    [SERVICE_OXYGENTHERAPY]: "oxygenTherapy",
    [SERVICE_PALLIATIVE_CARE]: "palliativeCare",
    [SERVICE_PALLIATIVE_CERTIFICATE]: "palliativeCertificate",
    [SERVICE_PARENTERAL_NUTRITRION]: "parenteralNutrition",
    [SERVICE_PEOPLEWHOAREDANGEROUS]: "peopleWhoAreDangerous",
    [SERVICE_PEOPLEWITHADDICTIONS]: "peopleWithAddictions",
    [SERVICE_PEOPLEWITHORIENTATIONDISORDER]: "peopleWithOrientationDisorder",
    [SERVICE_PROTECTEDAREA]: "protectedArea",
    [SERVICE_PSYCHIATRIC_CARE]: "psychiatricCare",
    [SERVICE_SPECIALISED_INTENSIVE_NURSE]: "specialisedIntensiveNurse",
    [SERVICE_STATIC_CARE_DISABLED_PATIENTS]: "staticCareDisabledPatients",
    [SERVICE_TAKINGOVERBODYCARE]: "takingOverBodyCare",
    [SERVICE_TRACHEOSTOMY]: "helpToBreathe",
    [SERVICE_VISUALLY_IMPAIRED]: "visuallyImpaired",
  },
  [ONTOLOGIES.SERVICE_EXPLANATIONS]: {
    [SERVICE_BASIC_CARE]: "basicCare",
    [SERVICE_BASIC_MEDICAL_CARE]: "basicMedicalCare",
    [SERVICE_CARE_FOR_CHILDREN_AND_TEENAGERS]: "careForChildrenAndTeenagers",
    [SERVICE_CARE_FOR_YOUTH]: "careForYouth",
    [SERVICE_CARE_PROTECTED_AREA]: "protectedArea",
    [SERVICE_CLOSED_AREA]: "closedArea",
    [SERVICE_COMPANIONSHIP]: "companionship",
    [SERVICE_DEMENTIA]: "dementiaCare",
    [SERVICE_PALLIATIVE_CARE]: "palliativeCare",
    [SERVICE_PALLIATIVE_CERTIFICATE]: "sapv",
    [SERVICE_PROTECTEDAREA]: "protectedArea",
    [SERVICE_PSYCHIATRIC_CARE]: "psychiatricCare",
    [SERVICE_SPECIALISED_INTENSIVE_NURSE]: "intensiveCare",
    [SERVICE_STATIC_CARE_DISABLED_PATIENTS]: "staticCareForDisabledPatients",
    [SERVICE_TRACHEOSTOMY]: "tracheostomy",
  },
  [ONTOLOGIES.SHARE_MODES]: {},
  [ONTOLOGIES.SHORT_TERM_GRANT]: {
    [SHORT_TERM_CARE_GRANT_39]: "paragraph39",
    [SHORT_TERM_CARE_GRANT_42]: "paragraph42",
    [SHORT_TERM_CARE_GRANT_COMBINATION]: "combination",
  },
  [ONTOLOGIES.SOLUTION]: {
    [SOLUTION_AMBULATORY_ASSISTED_COMMUNITY]: "ambulatoryAssistedCommunity",
    [SOLUTION_AMBULATORY_ASSISTED_LIVING]: "ambulatoryAssistedLiving",
    [SOLUTION_AMBULATORY_PSYCHIATRIC_CARE]: "ambulatoryPsychiatricCare",
    [SOLUTION_AMBULATORY_PSYCHIATRIC_REHAB]: "ambulatoryPsychiatricRehab",
    [SOLUTION_ASSISTED_LIVING]: "assistedLiving",
    [SOLUTION_DAILY_LIVING_SUPPORT_SERVICES]: "dailyLivingSupportServices",
    [SOLUTION_DAY_CARE]: "dayCare",
    [SOLUTION_DAY_CARE_CENTRE]: "dayCareCentre",
    [SOLUTION_DAY_HOSPITALIZATION]: "dayHospitalization",
    [SOLUTION_FULL_HOSPITALIZATION]: "fullHospitalization",
    [SOLUTION_FULL_TIME_MOBILE_CARE]: "fullTimeMobileCare",
    [SOLUTION_GERONTOPSYCHIATRIC_DAY_CLINIC]: "gerontopsychiatricDayClinic",
    [SOLUTION_HELP_AT_HOME]: "helpAtHome",
    [SOLUTION_HOME_CARE]: "homeCare",
    [SOLUTION_HOSPICE_ASSOCIATION]: "hospice",
    [SOLUTION_HOSPICE_MOBILE]: "hospiceMobile",
    [SOLUTION_HOSPICE_PARTIALLY_MOBILE]: "hospicePartiallyMobile",
    [SOLUTION_HOSPICE_STATIC]: "hospiceStatic",
    [SOLUTION_INTENSIVE_PSYCHIATRIC_CARE_HOME]: "intensivePsychiatricCareHome",
    [SOLUTION_LONGTERM_PSYCHIATRIC_CARE]: "longtermPsychiatricCare",
    [SOLUTION_MEDICAL_OCCUPATIONAL_REHAB]: "nedicalOccupationalRehab",
    [SOLUTION_MEDICAL_SUPPLIES]: "medicalSupplies",
    [SOLUTION_MOBILE_CARE]: "mobileCare",
    [SOLUTION_NIGHT_CARE_MOBILE]: "nightCareMobile",
    [SOLUTION_NIGHT_CARE_STATIC]: "nightCareStatic",
    [SOLUTION_PSYCHIATRIC_DAY_CLINIC]: "psychiatricDayClinic",
    [SOLUTION_REHAB_DAY_HOSPITALIZATION]: "rehabDayHospitalization",
    [SOLUTION_REHAB_FULL_HOSPITALIZATION]: "rehabFullHospitalization",
    [SOLUTION_REHAB_MOBILE]: "rehabMobile",
    [SOLUTION_SHARED_FLAT]: "sharedFlat",
    [SOLUTION_SHORT_TERM_CARE_PSYCHIATRIC]: "shortTermCarePsychiatric",
    [SOLUTION_SHORT_TERM_STATIC_CARE]: "shortTermStaticCare",
    [SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_ADDICTIONS]:
      "specialLivingArrangementsAddictions",
    [SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_INTELLECTUAL]:
      "specialLivingArrangementsIntellectual",
    [SOLUTION_SPECIAL_LIVING_ARRANGEMENTS_PSYCHIATRIC]:
      "specialLivingArrangementsPsychiatric",
    [SOLUTION_STATIC_CARE]: "staticCare",
    [SOLUTION_STATIONARY_PSYCHIATRIC_REHAB]: "stationaryPsychiatricRehab",
    [SOLUTION_WFBM]: "wfbm",
  },
  // deprecated
  [ONTOLOGIES.SOLUTION_B_TO_C]: {},
  [ONTOLOGIES.SPECIAL_CARE_NEEDS]: {
    [SPECIAL_CARE_NEEDS.CLOSED_AREA]: "protectedClosedArea",
    [SPECIAL_CARE_NEEDS.DEMENTIA]: "dementia",
    [SPECIAL_CARE_NEEDS.INTENSIVE_CARE]: "intensiveCare",
    [SPECIAL_CARE_NEEDS.OPEN_AREA]: "protectedOpenArea",
    [SPECIAL_CARE_NEEDS.OTHER]: "other",
    [SPECIAL_CARE_NEEDS.PALLIATIVE_CARE]: "palliativeCare",
    [SPECIAL_CARE_NEEDS.PSYCHIATRIC_CARE]: "psychiatricCare",
  },
  [ONTOLOGIES.SPECIALIZATIONS]: {
    [HOME_CARE_SPECIALIZATION_COMPRESSION_THERAPY]: "compressionTherapy",
    [HOME_CARE_SPECIALIZATION_DECUBITUS_PROPHYLAXIS]: "decubitusProphylaxis",
    [HOME_CARE_SPECIALIZATION_DRAINAGE]: "drainage",
    [HOME_CARE_SPECIALIZATION_ENTERAL_NUTRITION]: "enteralNutrition",
    [HOME_CARE_SPECIALIZATION_INCONTINENCE]: "incontinence",
    [HOME_CARE_SPECIALIZATION_INCONTINENCE_DISCHARGING]:
      "incontinenceDischarging",
    [HOME_CARE_SPECIALIZATION_INFUSION_THERAPY]: "infusionTherapy",
    [HOME_CARE_SPECIALIZATION_MEDICATION]: "medication",
    [HOME_CARE_SPECIALIZATION_MONITORING]: "monitoring",
    [HOME_CARE_SPECIALIZATION_OXYGEN]: "oxygen",
    [HOME_CARE_SPECIALIZATION_PAIN_THERAPY]: "painTherapy",
    [HOME_CARE_SPECIALIZATION_PARENTERAL_NUTRITION]: "parenteralNutrition",
    [HOME_CARE_SPECIALIZATION_RESPIRATORY_THERAPY]: "respiratoryTherapy",
    [HOME_CARE_SPECIALIZATION_STOMA]: "stoma",
    [HOME_CARE_SPECIALIZATION_TRACHEOSTOMY_THERAPY]: "tracheostomyTherapy",
    [HOME_CARE_SPECIALIZATION_VENTILATION]: "ventilationOxygen",
    [HOME_CARE_SPECIALIZATION_WOUND_CARE]: "woundCare",
    [SPECIALIZATION_ACUTE_GERIATRICS]: "acuteGeriatrics",
    [SPECIALIZATION_ADDICTION]: "addiction",
    [SPECIALIZATION_ADDICTOLOGY]: "addictology",
    [SPECIALIZATION_ALLERGOLOGY]: "allergology",
    [SPECIALIZATION_ANESTHESIOLOGY]: "anesthesiology",
    [SPECIALIZATION_ANGIOLOGY]: "angiology",
    [SPECIALIZATION_CARDIOLOGICAL_EARLY_REHA]:
      "cardiologicalEarlyRehabilitation",
    [SPECIALIZATION_CARDIOLOGY]: "cardiology",
    [SPECIALIZATION_COGNITIVE_BEHAVIORAL_UNIT]: "cognitiveBehavioralUnit",
    [SPECIALIZATION_DERMATOLOGY]: "dermatology",
    [SPECIALIZATION_DIABETIC_FOOT]: "diabeticFoot",
    [SPECIALIZATION_DIABETOLOGY]: "diabetology",
    [SPECIALIZATION_DIGESTIVE_SURGERY]: "digestiveSurgery",
    [SPECIALIZATION_ENDOCRINOLOGY]: "endocrinology",
    [SPECIALIZATION_ENT]: "ent",
    [SPECIALIZATION_GASTROENTEROLOGY]: "gastroenterology",
    [SPECIALIZATION_GENERAL_SURGERY]: "generalSurgery",
    [SPECIALIZATION_GERIATRICS]: "geriatrics",
    [SPECIALIZATION_GYNAECOLOGY]: "gynaecology",
    [SPECIALIZATION_HAEMATOLOGY]: "haematology",
    [SPECIALIZATION_HEPATOLOGY]: "hepatology",
    [SPECIALIZATION_ICU_CARDIOLOGY]: "icuCardiology",
    [SPECIALIZATION_ICU_ECMO_CORONA]: "icuECMOCorona",
    [SPECIALIZATION_ICU_GASTROLOGY]: "icuGastrology",
    [SPECIALIZATION_ICU_HIGH_CORONA]: "icuHighCorona",
    [SPECIALIZATION_ICU_LOW_CORONA]: "icuCorona",
    [SPECIALIZATION_ICU_NEUROVASCULAR]: "icuNeurovascular",
    [SPECIALIZATION_INFECTIOUS_DISEASE]: "infectiousDisease",
    [SPECIALIZATION_INTERNAL_MEDICAL_EARLY_REHA]:
      "internalMedicalEarlyRehabilitation",
    [SPECIALIZATION_INTERNAL_MEDICINE]: "internalMedicine",
    [SPECIALIZATION_MAXILLOFACIAL_SURGERY]: "maxillofacialSurgery",
    [SPECIALIZATION_MEDICAL_REANIMATION]: "medicalReanimation",
    [SPECIALIZATION_NEPHROLOGY]: "nephrology",
    [SPECIALIZATION_NEUROLOGY]: "neurology",
    [SPECIALIZATION_NEUROPEDIATRIY]: "neuroPediatry",
    [SPECIALIZATION_NEUROSURGERY]: "neurosurgery",
    [SPECIALIZATION_NORMAL_STATION]: "normalStation",
    [SPECIALIZATION_OBESITY]: "obesity",
    [SPECIALIZATION_ONCOLOGY]: "oncology",
    [SPECIALIZATION_ONCOLOGY_BREAST_GLANDS]: "oncologyBreastGlands",
    [SPECIALIZATION_ONCOLOGY_CENTRAL_NERVOUS_SYSTEM]:
      "oncologyCentralNervousSystem",
    [SPECIALIZATION_ONCOLOGY_DIGESTIVE_ORGANS]: "oncologyDigestiveOrgans",
    [SPECIALIZATION_ONCOLOGY_FEMALE_GENITAL]: "oncologyFemaleGenital",
    [SPECIALIZATION_ONCOLOGY_KIDNEY_URINARY_MALE_GENITAL]:
      "oncologyUrinaryKidneyMaleGenitals",
    [SPECIALIZATION_ONCOLOGY_LOCOMOTOR_ORGANS]: "oncologyLocomotorOrgans",
    [SPECIALIZATION_ONCOLOGY_MALIGNANT_SYSTEMIC_DISEASES]:
      "oncologyMalignantSystemicDiseases",
    [SPECIALIZATION_ONCOLOGY_PHARYNX_LARYNX]: "oncologyPharync",
    [SPECIALIZATION_ONCOLOGY_RESPIRATORY_ORGANS]: "oncologyRespiratoryOrgans",
    [SPECIALIZATION_ONCOLOGY_SKIN]: "oncologySkin",
    [SPECIALIZATION_ONCOLOGY_THYROID]: "oncologyThyroid",
    [SPECIALIZATION_OPHTHALMOLOGY]: "ophthalmology",
    [SPECIALIZATION_ORTHOGERIATRICS]: "orthogeriatrics",
    [SPECIALIZATION_ORTHOPEDICS]: "orthopedics",
    [SPECIALIZATION_ORTHOPEDICS_LOWER_LIMBS]: "orthopedicsLowerLimbs",
    [SPECIALIZATION_ORTHOPEDICS_SOS_MAINS]: "orthopedicsSosMains",
    [SPECIALIZATION_ORTHOPEDICS_SPINE]: "orthopedicsSpine",
    [SPECIALIZATION_ORTHOPEDICS_UPPER_LIMBS]: "orthopedicsUpperLimbs",
    [SPECIALIZATION_PALLIATIVE_CARE]: "palliativeCare",
    [SPECIALIZATION_PARENTS_AND_CHILD_REHAB]: "parentsAndChildRehab",
    [SPECIALIZATION_PEDIATRICS]: "pediatrics",
    [SPECIALIZATION_PHASEB]: "phaseB",
    [SPECIALIZATION_PHASEC]: "phaseC",
    // [SPECIALIZATION_EARLY_REHAB]: "earlyRehab",
    [SPECIALIZATION_PHASECPLUS]: "phaseCplus",
    [SPECIALIZATION_PHASED]: "phaseD",
    [SPECIALIZATION_PHYSICAL_MEDICINE]: "physicalMedicine",
    [SPECIALIZATION_PLASTIC_SURGERY]: "plasticSurgery",
    [SPECIALIZATION_PNEUMOLOGICAL_EARLY_REHA]:
      "pneumologicalEarlyRehabilitation",
    [SPECIALIZATION_PNEUMOLOGY]: "pneumology",
    [SPECIALIZATION_PSYCHIATRY]: "psychiatry",
    [SPECIALIZATION_PSYCHOSOMATIC]: "psychosomatic",
    [SPECIALIZATION_RADIOLOGY]: "radiology",
    [SPECIALIZATION_RHEUMATISM]: "rheumatism",
    [SPECIALIZATION_SURGICAL_RESUSCITATION]: "surgicalResuscitation",
    [SPECIALIZATION_THORACIC_SURGERY]: "thoracicSurgery",
    [SPECIALIZATION_TRAUMA_SURGERY]: "traumaSurgery",
    [SPECIALIZATION_UROLOGY]: "urology",
    [SPECIALIZATION_VASCULAR_SURGERY]: "vascularSurgery",
    [SPECIALIZATION_WEANING]: "weaning",
  },
  [ONTOLOGIES.SUBSTANCE_USE]: {
    [SUBSTANCE_USE_NO]: "no",
    [SUBSTANCE_USE_UNKNOWN]: "unknown",
    [SUBSTANCE_USE_YES]: "yes",
  },
  [ONTOLOGIES.TABLE_SORTING]: {
    [SEARCH_TABLE_SORTING_DEFAULT]: "sortByDefault",
    [SEARCH_TABLE_SORTING_DISTANCE]: "sortByDistance",
    [SEARCH_TABLE_SORTING_NAME]: "sortByName",
  },
  [ONTOLOGIES.TECHNICAL_EQUIPMENT]: {},
  [ONTOLOGIES.TRAFFIC_LIGHT]: {},
  [ONTOLOGIES.TRANSITIONAL_CARE_REQUEST_STATUS]: {
    [AUCTION_REQUEST_ACCEPTED]: "accepted",
    [AUCTION_REQUEST_DECLINED]: "declined",
    [AUCTION_REQUEST_REJECTED]: "rejected",
    [AUCTION_REQUEST_SENT]: "sent",
  },
  [ONTOLOGIES.TRANSPORT_TYPE]: {
    [TRANSPORT_TYPE_AMBULANCE_LYING_DOWN]: "ambulanceLyingDown",
    [TRANSPORT_TYPE_AMBULANCE_SITTING]: "ambulanceSitting",
    [TRANSPORT_TYPE_EMERGENCY_VEHICLE]: "emergencyVehicle",
    [TRANSPORT_TYPE_HELICOPTER]: "helicopter",
    [TRANSPORT_TYPE_PERSONAL_CAR]: "personalCar",
    [TRANSPORT_TYPE_PUBLIC_TRANSPORT]: "publicTransport",
    [TRANSPORT_TYPE_TAXI]: "taxi",
  },
  [ONTOLOGIES.UNIVERSAL_SEARCH_RESOURCE]: {
    [UNIVERSAL_SEARCH_RESOURCES.ACCOUNT]: "account",
    [UNIVERSAL_SEARCH_RESOURCES.COMPANY]: "company",
    [UNIVERSAL_SEARCH_RESOURCES.CONSULTANT]: "consultant",
    [UNIVERSAL_SEARCH_RESOURCES.INSURANCE]: "insurance",
    [UNIVERSAL_SEARCH_RESOURCES.RECEIVER]: "receiver",
    [UNIVERSAL_SEARCH_RESOURCES.SENDER]: "sender",
  },
  [ONTOLOGIES.VIGILANCE]: {
    [VIGILANCE_AGITATED]: "agitated",
    [VIGILANCE_AWAKE]: "awake",
    [VIGILANCE_CALM]: "calm",
    [VIGILANCE_COMATOSE]: "comatose",
    [VIGILANCE_RESPONSIVE]: "responsive",
    [VIGILANCE_SOMNOLENT]: "somnolent",
    [VIGILANCE_SOPORIFIC]: "soporific",
  },
  [ONTOLOGIES.VISIT_TIME]: {
    [VISIT_TIME.AFTERNOON]: "afternoon",
    [VISIT_TIME.EVENING]: "evening",
    [VISIT_TIME.MORNING]: "morning",
    [VISIT_TIME.NO_PREFERENCE]: "noPreference",
    [VISIT_TIME.NOON]: "noon",
    [VISIT_TIME.OTHER]: "other",
  },
  [OTHER_EQUIPMENT]: {
    [TECHNICAL_EQUIPMENT_DIALYSIS]: "dialysis",
    [TECHNICAL_EQUIPMENT_MONITORING_BREATHING]: "monitoringBreathing",
    [TECHNICAL_EQUIPMENT_MONITORING_CIRCULATION]: "monitoringCirculation",
    [TECHNICAL_EQUIPMENT_MONITORING_METABOLISM]: "monitoringMetabolism",
  },
} as const;

/**
 * Ensures `ontologies` matches the structure of the ontologies in the Translations in the ACP.
 */
const _ontologiesSyncWithTranslationsCheck: Record<
  keyof Translations["ontologies"],
  Record<number, OntologyStructValue>
> = ontologies;

export const ontologiesOrders: {
  [index in OntologyType]?: {
    [key in number]: number;
  };
} = {
  [ONTOLOGIES.ADMISSIONS_FORM_SOLUTIONS]: {
    [ADMISSIONS_FORM_SOLUTIONS.LONG_TERM]: 1,
    [ADMISSIONS_FORM_SOLUTIONS.OTHER]: 3,
    [ADMISSIONS_FORM_SOLUTIONS.SHORT_TERM]: 2,
  },
  [ONTOLOGIES.ADMISSIONS_MENTAL_ABILITY]: {
    [MENTAL_ABILITY.DEMENT]: 3,
    [MENTAL_ABILITY.FULLY_ORIENTED]: 1,
    [MENTAL_ABILITY.IMPAIRED]: 2,
  },
  [ONTOLOGIES.ADMISSIONS_MOBILITY]: {
    [MOBILITY.BEDRIDDEN]: 5,
    [MOBILITY.FULLY_MOBILE]: 1,
    [MOBILITY.NEEDS_SUPPORT]: 2,
    [MOBILITY.WALKING_AID]: 3,
    [MOBILITY.WHEELCHAIR]: 4,
  },
  [ONTOLOGIES.CARE_FREQUENCY]: {
    [CARE_FREQUENCY.DAILY]: 1,
    [CARE_FREQUENCY.DONT_KNOW]: 3,
    [CARE_FREQUENCY.WEEKLY]: 2,
  },
  [ONTOLOGIES.CARE_LEVEL]: {
    [CARE_LEVELS.FIVE]: 5,
    [CARE_LEVELS.FOUR]: 4,
    [CARE_LEVELS.NONE]: 6,
    [CARE_LEVELS.ONE]: 1,
    [CARE_LEVELS.THREE]: 3,
    [CARE_LEVELS.TWO]: 2,
    [CARE_LEVELS.UNKNOWN]: 7,
  },
  [ONTOLOGIES.CURRENT_CARE]: {
    [CURRENT_CARE_BASE_TYPES.BY_RELATIVES]: 2,
    [CURRENT_CARE_BASE_TYPES.FACILITY]: 4,
    [CURRENT_CARE_BASE_TYPES.MOBILE]: 3,
    [CURRENT_CARE_BASE_TYPES.NONE]: 1,
  },
  [ONTOLOGIES.CURRENT_CARE_FACILITY_TYPES]: {
    [CURRENT_CARE_FACILITY_TYPES.ASSISTED_LIVING]: 2,
    [CURRENT_CARE_FACILITY_TYPES.OTHER]: 4,
    [CURRENT_CARE_FACILITY_TYPES.SHORT_TERM]: 1,
    [CURRENT_CARE_FACILITY_TYPES.STATIC_CARE]: 3,
  },
  [ONTOLOGIES.FILE_SHARE_MODE]: {
    [FILE_SHARE_MODE_ALL]: 2,
    [FILE_SHARE_MODE_NONE]: 1,
    [FILE_SHARE_MODE_SELECTED]: 3,
  },
  [ONTOLOGIES.GENDER_EXTENDED]: {
    [GENDER.DIVERSE]: 3,
    [GENDER.FEMALE]: 2,
    [GENDER.MALE]: 1,
    [GENDER.UNSPECIFIED]: 4,
  },
  [ONTOLOGIES.GRANT_STATUS]: {
    [GRANT_STATUS_APPLIED_FOR]: 2,
    [GRANT_STATUS_EXISTS]: 3,
    [GRANT_STATUS_NOT_APPLIED]: 1,
  },
  [ONTOLOGIES.INFORMATION_SYSTEM]: {
    [INF_SYS_CONNEXT_VIVENDI]: 4,
    [INF_SYS_CURASOFT]: 6,
    [INF_SYS_DAN_PRODUKTE]: 3,
    [INF_SYS_GODO_SYSTEMS]: 10,
    [INF_SYS_MEDIFOX]: 2,
    [INF_SYS_MYNEVA]: 1,
    [INF_SYS_NOVENTI_CARE]: 5,
    [INF_SYS_OTHER]: 11,
    [INF_SYS_SENSO]: 9,
    [INF_SYS_SINFONIE]: 8,
    [INF_SYS_SNAP]: 7,
  },
  [ONTOLOGIES.LIVING_SITUATION]: {
    [LIVING_SITUATION_ALONE]: 1,
    [LIVING_SITUATION_CAREHOME]: 3,
    [LIVING_SITUATION_IN_ELDERLY_HOME]: 8,
    [LIVING_SITUATION_NO_RESIDENCE]: 5,
    [LIVING_SITUATION_OTHER]: 7,
    [LIVING_SITUATION_SHARED_FLAT]: 6,
    [LIVING_SITUATION_WITH_FAMILY]: 2,
  },
  [ONTOLOGIES.MOBILITY]: {
    [MOBILITY_CRUTCH]: 4,
    [MOBILITY_MEDICALISED_BED]: 8,
    [MOBILITY_ROLLATOR]: 6,
    [MOBILITY_WALK_WITH_HELP]: 2,
    [MOBILITY_WALK_WITHOUT_HELP]: 1,
    [MOBILITY_WALKING_FRAME]: 5,
    [MOBILITY_WALKING_STICK]: 3,
    [MOBILITY_WHEELCHAIR]: 7,
  },
  [ONTOLOGIES.PATIENT_TYPE]: {
    [SEARCH_TYPE_CARE]: 1,
    [SEARCH_TYPE_HOME_CARE]: 6,
    [SEARCH_TYPE_HOSPITAL]: 3,
    [SEARCH_TYPE_MEDICAL_SUPPLIES]: 5,
    [SEARCH_TYPE_REHABILITATION]: 2,
  },
  [ONTOLOGIES.REFERRAL_SOURCE_MOBILE]: {
    [REFERRAL_SOURCE.CONSULTANT]: 4,
    [REFERRAL_SOURCE.INTERNET_RESEARCH]: 3,
    [REFERRAL_SOURCE.MEDICAL_PRACTICE]: 2,
    [REFERRAL_SOURCE.ONLINE_PORTALS]: 6,
    [REFERRAL_SOURCE.OTHER]: 8,
    [REFERRAL_SOURCE.PROVIDER_PREVIOUSLY_USED]: 7,
    [REFERRAL_SOURCE.PROVIDER_WEBSITE]: 5,
    [REFERRAL_SOURCE.RECOMMENDATION]: 1,
  },
  [ONTOLOGIES.REFERRAL_SOURCE_STATIC]: {
    [REFERRAL_SOURCE.CONSULTANT]: 4,
    [REFERRAL_SOURCE.INTERNET_RESEARCH]: 3,
    [REFERRAL_SOURCE.MEDICAL_PRACTICE]: 2,
    [REFERRAL_SOURCE.ONLINE_PORTALS]: 6,
    [REFERRAL_SOURCE.OTHER]: 8,
    [REFERRAL_SOURCE.PROVIDER_PREVIOUSLY_USED]: 7,
    [REFERRAL_SOURCE.PROVIDER_WEBSITE]: 5,
    [REFERRAL_SOURCE.RECOMMENDATION]: 1,
  },
  [ONTOLOGIES.REHABILITATION_POTENTIAL]: {
    [REHABILITATION_POTENTIAL_EVALUATION_EXTREMELY_NEGATIVE]: 5,
    [REHABILITATION_POTENTIAL_EVALUATION_EXTREMELY_POSITIVE]: 1,
    [REHABILITATION_POTENTIAL_EVALUATION_MODERATE]: 3,
    [REHABILITATION_POTENTIAL_EVALUATION_NEGATIVE]: 4,
    [REHABILITATION_POTENTIAL_EVALUATION_POSITIVE]: 2,
  },
  [ONTOLOGIES.RELATIONSHIP_TO_PATIENT]: {
    [RELATIONSHIP_TO_PATIENT.CHILD]: 4,
    [RELATIONSHIP_TO_PATIENT.GUARDIAN]: 1,
    [RELATIONSHIP_TO_PATIENT.OTHER]: 5,
    [RELATIONSHIP_TO_PATIENT.PARENT]: 3,
    [RELATIONSHIP_TO_PATIENT.SPOUSE]: 2,
  },
  [ONTOLOGIES.RELIEF_SERVICES]: {
    [RELIEF_SERVICES_PARAGRAPH_A]: 1,
    [RELIEF_SERVICES_PARAGRAPH_B]: 2,
  },
  [ONTOLOGIES.REQUIRED_CARE_BASIC_TYPES]: {
    [REQUIRED_CARE_BASIC_TYPES.BASIC_FULL_BODY]: 2,
    [REQUIRED_CARE_BASIC_TYPES.BASIC_MEAL_PREP]: 3,
    [REQUIRED_CARE_BASIC_TYPES.BASIC_MINIMAL]: 1,
    [REQUIRED_CARE_BASIC_TYPES.BASIC_MOBILITY]: 4,
  },
  [ONTOLOGIES.REQUIRED_CARE_TYPES]: {
    [REQUIRED_CARE_TYPES.BASIC]: 1,
    [REQUIRED_CARE_TYPES.DOMESTIC_SUPPORT]: 3,
    [REQUIRED_CARE_TYPES.MEDICAL_TREATMENT]: 2,
    [REQUIRED_CARE_TYPES.OTHER]: 5,
    [REQUIRED_CARE_TYPES.SUPPORT_SERVICES]: 4,
  },
  [ONTOLOGIES.SALUTATION]: {
    [GENDER.DIVERSE]: 3,
    [GENDER.FEMALE]: 2,
    [GENDER.MALE]: 1,
  },
  [ONTOLOGIES.SEARCH_REASON]: {
    [SEARCH_REASON.HOSIPTAL_DISCHARGE]: 3,
    [SEARCH_REASON.INCREASED_NEED]: 1,
    [SEARCH_REASON.OTHER]: 5,
    [SEARCH_REASON.PROVIDER_CHANGE_REQUIRED]: 4,
    [SEARCH_REASON.RELATIVES_UNABLE]: 2,
  },
  [ONTOLOGIES.SHORT_TERM_GRANT]: {
    [SHORT_TERM_CARE_GRANT_39]: 2,
    [SHORT_TERM_CARE_GRANT_42]: 1,
    [SHORT_TERM_CARE_GRANT_COMBINATION]: 3,
  },
  [ONTOLOGIES.SPECIAL_CARE_NEEDS]: {
    [SPECIAL_CARE_NEEDS.CLOSED_AREA]: 3,
    [SPECIAL_CARE_NEEDS.DEMENTIA]: 1,
    [SPECIAL_CARE_NEEDS.INTENSIVE_CARE]: 5,
    [SPECIAL_CARE_NEEDS.OPEN_AREA]: 2,
    [SPECIAL_CARE_NEEDS.OTHER]: 7,
    [SPECIAL_CARE_NEEDS.PALLIATIVE_CARE]: 6,
    [SPECIAL_CARE_NEEDS.PSYCHIATRIC_CARE]: 4,
  },
  [ONTOLOGIES.TRANSPORT_TYPE]: {
    [TRANSPORT_TYPE_AMBULANCE_LYING_DOWN]: 2,
    [TRANSPORT_TYPE_AMBULANCE_SITTING]: 3,
    [TRANSPORT_TYPE_EMERGENCY_VEHICLE]: 1,
    [TRANSPORT_TYPE_HELICOPTER]: 7,
    [TRANSPORT_TYPE_PERSONAL_CAR]: 6,
    [TRANSPORT_TYPE_PUBLIC_TRANSPORT]: 4,
    [TRANSPORT_TYPE_TAXI]: 5,
  },
  [ONTOLOGIES.VIGILANCE]: {
    [VIGILANCE_AGITATED]: 1,
    [VIGILANCE_AWAKE]: 3,
    [VIGILANCE_CALM]: 2,
    [VIGILANCE_COMATOSE]: 7,
    [VIGILANCE_RESPONSIVE]: 4,
    [VIGILANCE_SOMNOLENT]: 5,
    [VIGILANCE_SOPORIFIC]: 6,
  },
  [ONTOLOGIES.VISIT_TIME]: {
    [VISIT_TIME.AFTERNOON]: 3,
    [VISIT_TIME.EVENING]: 4,
    [VISIT_TIME.MORNING]: 1,
    [VISIT_TIME.NO_PREFERENCE]: 5,
    [VISIT_TIME.NOON]: 2,
    [VISIT_TIME.OTHER]: 6,
  },
} as const;

export {
  getKey,
  getName,
  getOntologies,
  getOntology,
  getValueFromTranslation,
  getValues,
} from "./utils";
